export const SIDENAV_KEYS = {
  PROFILE: 'sidenav_profile',
  NOTIFICATION: 'sidenav_notification',
  SETTINGS: 'sidenav_settings',
  TRANSFER: 'sidenav_transfer',
  EXCHANGE_RATE: 'sidenav_exchangeRate',
  CONTACT_US: 'sidenav_contactUs',
  SUGGESTION: 'sidenav_suggestion',
  TERMS_AND_CONDITIONS: 'sidenav_termsAndConditons',
  TOUCH_ID: 'sidenav_touchID',
  FAQ: 'sidenav_FAQ',
  BENEFICIARIES: 'sidenav_beneficiaries',
  MY_QR_CODE: 'sidenav_myQRCode',
  OFFERS: 'sidenav_offers',
  LOGOUT: 'sidenav_logout',
  LOGOUT_MESSAGE: 'sidenav_logoutMessage',
  PROFILE_KEYS: {
    TITLE: 'profile_title',
    SUBTITLE: 'profile_subtitle',
    EDIT: 'profile_edit',
    MOBILE_NUMBER: 'profile_mobileNumber',
    DOB: 'profile_dob',
    ADDRESS: 'profile_address',
    CAMERA: 'profile_camera',
    GALLERY: 'profile_gallery',
    DELETE: 'profile_delete',
  },
  NOTIFICATION_KEYS: {
    TITLE: 'notification_title',
    SUBTITLE: 'notification_subtitle',
  },
  SETTINGS_KEYS: {
    TITLE: 'settings_title',
    SUBTITLE: 'settings_subtitle',
    CHANGE_PASSWORD: 'settings_changePassword',
    CHANGE_PIN: 'settings_changePIN',
    CHANGE_LANGUAGE: 'settings_changeLanguage',
    LOGOUT: 'settings_logout',
    CHANGE_PASSWORD_KEYS: {
      TITLE: 'settings_changePassword_title',
      SUBTITLE: 'settings_changePassword_subtitle',
      OLD_PASSWORD: 'settings_changePassword_oldPassword',
      NEW_PASSWORD: 'settings_changePassword_newPassword',
      CONFIRM_NEW_PASSWORD: 'settings_changePassword_confirmNewPassword',
      SUBMIT: 'settings_changePassword_submit',
    },
    CHANGE_PIN_KEYS: {
      TITLE: 'settings_changePIN_title',
      SUBTITLE: 'settings_changePIN_subtitle',
      OLD_PIN: 'settings_changePIN_oldPIN',
      NEW_PIN: 'settings_changePIN_newPIN',
      CONFIRM_NEW_PIN: 'settings_changePIN_confirmNewPIN',
      SUBMIT: 'settings_changePIN_submit',
    },
    CHANGE_LANGUAGE_KEYS: {
      TITLE: 'settings_changeLanguage_title',
      SUBTITLE: 'settings_changeLanguage_subtitle',
    },
  },
  EXCHANGE_RATE_KEYS: {
    TITLE: 'exchangeRate_title',
    SUBTITLE: 'exchangeRate_subtitle',
    BUY_CURRENCY: 'exchangeRate_buyCurrency',
    SELL_CURRENCY: 'exchangeRate_sellCurrency',
    SUBMIT: 'exchangeRate_submit',
    RATE_TYPE: 'exchangeRate_rateType',
    BUY_RATE: 'exchangeRate_buyRate',
    SELL_RATE: 'exchangeRate_sellRate',
  },
  CONTACT_US_KEYS: {
    TITLE: 'contactUs_title',
    SUBTITLE: 'contactUs_subtitle',
    HOTLINE_LABEL: 'contactUs_hotlineLabel',
    HOTLINE_VALUE: 'contactUs_hotlineValue',
    WORKING_HOURS_LABEL: 'contactUs_workingHoursLabel',
    WORKING_HOURS_VALUE: 'contactUs_workingHoursValue',
    EMAIL_LABEL: 'contactUs_emailLabel',
    EMAIL_VALUE: 'contactUs_emailValue',
    WEBSITE_LABEL: 'contactUs_websiteLabel',
    WEBSITE_VALUE: 'contactUs_websiteValue',
    ADDRESS_LABEL: 'contactUs_addressLabel',
    ADDRESS_VALUE: 'contactUs_addressValue',
    FOLLOW_US: 'contactUs_followUs',
  },
  SUGGESTION_KEYS: {
    TITLE: 'suggestion_title',
    SUBTITLE: 'suggestion_subtitle',
    CATEGORY: 'suggestion_category',
    FEEDBACK: 'suggestion_feedback',
    SUBMIT: 'suggestion_submit',
  },
  TERMS_AND_CONDITIONS_KEYS: {
    TITLE: 'termsAndConditions_title',
    CONFIRM_TERMS_CONDITION: 'termsAndConditions_confirm',
    ACCEPT: 'termsAndConditions_accept',
  },
  TOUCH_ID_KEYS: {
    TITLE: 'touchID_title',
    SUBTITLE: 'touchID_subtitle',
    SUBMIT: 'touchID_submit',
    AUTH_TITLE: 'touchID_authTitle',
    CANCEL: 'touchID_cancel',
    BACK: 'touchID_back',
    FAILED: 'touchID_failed',
    SUCCESS: 'touchID_success',
    CONFIRM: 'touchID_confirm',
  },
  FAQ_KEYS: {
    TITLE: 'faq_title',
    SUBTITLE: 'faq_subtitle',
  },
  QR_KEYS: {
    TITLE: 'qr_title',
    SUBTITLE: 'qr_subtitle',
    ACCOUNT_NUMBER: 'qr_accountNumber',
    SHARE: 'qr_share',
  },
  OFFERS_KEYS: {
    TITLE: 'offers_title',
    SUBTITLE: 'offers_subtitle',
  },
  SERVICEREQUEST_KEYS: {
    TITLE: 'serviceRequest_title',
    SUBTITLE: 'serviceRequest_subtitle',
    SUBTITLE1: 'serviceRequest_subtitle1',
    CATEGORY: 'serviceRequest_category',
    SUGGESTION: 'serviceRequest_suggestion',
    ACCOUNTNO: 'serviceRequest_accNo',
    REF_NUMBER: 'serviceRequest_refNo',
    BENENAME: 'serviceRequest_beneName',
    AMOUNT: 'serviceRequest_amount',
    SUBMIT: 'serviceRequest_submit',
  },
  SERVICEREQUEST_VIEW_KEYS: {
    TITLE: 'serviceRequest_view_title',
    SUBTITLE: 'serviceRequest_view_subtitle',
    SERVICEREQREFNO: 'serviceRequest_view_service_refNo',
    CUSTOMERNAME: 'serviceRequest_view_custName',
    REFERENCENO: 'serviceRequest_view_refNo',
    REFERENCE_NUMBER: 'serviceRequest_view_refNumber',
    ACCOUNTNO_1: 'serviceRequest_view_accountNumber',
    SERIAL: 'serviceRequest_view_serialNumber',
    NARRATION: 'serviceRequest_view_naration',
    REF: 'serviceRequest_view_ref',
    EMAILID: 'serviceRequest_view_mail',
    SUGGESTION: 'serviceRequest_view_suggestions',
    ACCOUNTNO: 'serviceRequest_view_accountNo',
    BENENAME: 'serviceRequest_view_beneName',
    status: 'serviceRequest_view_satus',
    REMARKS: 'serviceRequest_view_remarks',
    AMOUNT: 'serviceRequest_view_amount',
    TRANS_DATE: 'serviceRequest_view_transDate',
    SERVICENO: 'serviceRequest_view_service_serviceNo',
    FORM_DATE: 'from_date',
    TO_DATE: 'to_date',
    FORMAT: 'format',
    REPORT_NAME: 'report_name',
    CUSTOMER_ADDRESS: 'serviceRequest_view_customer_address',
    AMOUNT_DUE: 'serviceRequest_view_amount_due',
    DELINK_ACCOUNT_NO: 'serviceRequest_view_delink_account_no',
    DELINK: 'serviceRequest_view_delink',
    LINK_ACCOUNT_NO: 'serviceRequest_view_link_account_no',
    LINK_ACCOUNT: 'serviceRequest_view_link_account',
  },
}

export const LOAN_KEYS = {
  SELECT_ACCOUNT_KEYS: {
    TITLE: 'loan_selectAccount_title',
    SECONDARY_TEXT: 'loan_selectAccount_secondaryText',
    SUBTITLE: 'loan_selectAccount_subtitle',
    APPLY_BUTTON: 'loan_selectAccount_apply',
    APPLY_LOAN_TITLE: 'loan_apply_loan_title',
    APPLY_LOAN_CONFIRM_TITLE: 'loan_apply_loan_confirm_title',
  },
  DETAILS_KEYS: {
    TITLE: 'loan_selectAccount_title',
    SUBTITLE: 'loan_selectAccount_subtitle',
    ACCOUNT_NUMBER: 'loan_selectAccount_accountNumber',
    USER_REF_NO: 'loan_selectAccount_userRefNo',
    brnCode: 'loan_selectAccount_branchCode',
    currency: 'loan_selectAccount_currency',
    INCOME_RANGE_DETAILS: 'loan_details_incomeRangeDetails',
    ACCOUNT_DESCRIPTION: 'loan_selectAccount_accountDescription',
    PROD_CATEGORY: 'loan_selectAccount_prodCategory',
    CUSTOMER_ID: 'loan_selectAccount_customerID',
    VALUE_DATE: 'loan_selectAccount_valueDate',
    maturityDate: 'loan_selectAccount_maturityDate',
    AMOUNT_FINANCED: 'loan_selectAccount_amountFinanced',
    OUTSTANDING_BALANCE: 'loan_selectAccount_outstandingBalance',
    status: 'loan_selectAccount_status',
    PRINCIPAL_AMOUNT: 'loan_selectAccount_principalAmount',
    INTEREST_RATE: 'loan_selectAccount_interestRate',
    REPAYMENT_INSTALLMENT: 'loan_selectAccount_repaymentInstallment',
    AMOUNT_PAID: 'loan_selectAccount_amountPaid',
    NEXT_DATE: 'loan_selectAccount_nextpaymentdate',
    REPAYMENT_STATUS: 'loan_selectAccount_repaymentStatus',
    REMAINING_NO_PAYMENTS: 'loan_selectAccount_remainingNoOfPayments',
  },
  NEW_LOAN_KEYS: {
    TITLE: 'loan_details_title',
    SUBTITLE_2: 'loan_selectAccount_loanpayment',
    SUBTITLE_3: 'loan_selectAccount_loanpaymentsubtitle',
    LOAN_ACCOUNT_NO: 'loan_selectAccount_loanaccountno',
    LOAN_ACCOUNT_NO1: 'loan_selectAccount_loanaccountno1',
    LOAN_ACCOUNT_NO2: 'loan_selectAccount_loanaccountno2',
    FULL_PAYMENT: 'loan_selectAccount_fullpayment',
    PARTIAL: 'loan_selectAccount_partial',
    SUBTITLE: 'loan_details_subtitle',
    LOAN_AMOUNT: 'loan_details_loanAmount',
    AMOUNT: 'loan_selectAccount_amount',
    PAYMENT_MODE: 'loan_selectAccount_paymentmde',
    MONTH: 'loan_details_months',
    YEAR: 'loan_details_year',
    PURPOSE: 'loan_details_purposeOfLoan',
    TENURE: 'loan_details_tenure',
    TENURE_MONTHLY_OR_YEARLY: 'loan_details_tenureMonthlyOrYearly',
    TENURE_MONTHLY: 'loan_details_tenureMonthlyOrYearlyDetil',
    TENURE_DETAILS: 'loan_details_tenuredetails',
    SOURCE_INCOME: 'loan_details_sourceOfIncomeDetails',
    SOURCE: 'loan_details_sourceOfIncome',
    currency: 'loan_details_currency',
    INCOME_RANGE: 'loan_details_incomeRange',
    SUBMIT: 'loan_details_submit',
    CONFIRM: 'loan_details_confirm',
    SUCCESS_BUTTON: 'loan_details_success',
  },
  STATEMENT_SELECT_KEYS: {
    TITLE: 'account_statementSelect_title',
    REF: 'account_statementSelect_ref',
    REMARKS: 'account_statementSelect_remarks',
    AMOUNT: 'account_statementSelect_amount',
    MESSAGE: 'account_statementSelect_message',
    BUTTON: 'account_statementSelect_button',
    CURRENT_MONTH: 'account_statementSelect_currentMonth',
    CURRENT_PREVIOUS_MONTH: 'account_statementSelect_currentPreviousMonth',
    CURRENT_PREVIOUS_3_MONTHS: 'account_statementSelect_currentPrevious3Months',
  },
}

export const DEPOSITS_KEYS = {
  SELECT_TYPE_KEYS: {
    TITLE: 'deposits_select_title',
    TERM_DEPOSIT: 'deposits_select_termDeposit',
    DEPOSITE: 'deposits_select_depositeamount',
    VIEW: 'deposits_select_view',
    STATEMENT: 'deposits_select_statement',
  },
  TERMS_AND_CONDITIONS_KEYS: {
    TITlE: 'deposits_termsAndConditions',
    ACCEPT: 'deposits_termsAndConditions_accept',
  },
  TERM_DEPOSITS_KEYS: {
    TITLE: 'deposits_termDeposits_title',
    SUBTITLE: 'deposits_termDeposits_subtitle',
    SUBTITLE_1: 'deposits_termDeposits_subtitle1',
    SUBTITLE_6: 'deposits_termDeposits_subtitle6',
    CREATE_BUTTON: 'deposits_termDeposits_createButton',
    ACCOUNT_NUMBER: 'deposits_termDeposits_accountNumber',
    ACCOUNTNO: 'deposits_termDeposits_accountNo',
    TENURE: 'deposits_termDeposits_tenure',
    TENURE_VALUE: 'deposits_termDeposits_tenureValue',
    AMOUNT: 'deposits_termDeposits_amount',
    AMOUNT_DETAILS: 'deposits_termDeposits_amountDetails',
    TENURE_PERIOD: 'deposits_termDeposits_tenurePeriod',
    INTEREST_RATE: 'deposits_termDeposits_intrest',
    DAYS: 'deposits_termDeposits_days',
    MONTHS: 'deposits_termDeposits_months',
    YEARS: 'deposits_termDeposits_years',
    CURRENCY: 'deposits_termDeposits_details_currency',
    CREDIT_ACCOUNT_NO: 'deposits_termDeposits_details_creditAccount',
    DEBIT_ACCOUNT_NO: 'deposits_termDeposits_details_debitAccount',
    SCHEDULE_DATE: 'deposits_termDeposits_details_scheduledate_detail1',
    SCHEDULE_PAYMENT: 'deposits_termDeposits_details_Schedule_detail',
    SCHEDULE_DATE1: 'deposits_termDeposits_details_scheduledate_detail2',
    SCHEDULE_PAYMENT2: 'deposits_termDeposits_details_Schedule_detail3',
    PAYMENT_METHOD: 'deposits_termDeposits_interestPaymentMethod',
    PAYMENT: 'deposits_termDeposits_interestPayment',
    CREDIT_INTEREST_MONTHLY: 'deposits_termDeposits_creditInterestMonthly',
    AUTO_RENEWAL: 'deposits_termDeposits_autoRenewal',
    CREDIT_ON_MATURITY: 'deposits_termDeposits_creditInterestMaturity',
    PRINCIPAL: 'deposists_termDeposits_principal',
    CLOSE_ON_MATURITY: 'deposits_termDeposits_closeOnMaturity',
    ROLLOVER_PRINCIPAL: 'deposits_termDeposits_rolloverPrincipal',
    ROLLOVER_PRINCIPAL_INTEREST: 'deposits_termDeposits_rolloverPrincipalInterest',
    T_C: 'deposits_termDeposits_termsAndConditions',
    CONFIRM_BUTTON: 'deposits_termDeposits_confirmButton',
    SUCCESS_BUTTON: 'deposits_termDeposits_successButton',
    DEPOSIT_TYPE: 'deposits_termDeposits_depositType',
    OTP_ENTER: 'deposits_termDeposits_OTP',
    SUBMIT_BUTTON: 'deposits_termDeposits_submitButton',
    REMARKS: 'deposits_termDeposits_details_remark',
    CUSTOM_REMARK: 'deposits_termDeposits_details_customremark',
    RECIVERMOBILENO: 'deposits_termDeposits_details_recievermobile',
    RECIVERMOBILENO1: 'deposits_termDeposits_details_recievermobileno',
    CHARGES_BORNE_BY: 'deposits_termDeposits_details_chargesBorneBy',
    CREDIT_INTEREST_QUARTERLY: 'deposits_termDeposits_creditInterestQuarterly',
    DAYS: 'deposit_days',
    MONTHS: 'deposit_months',
    YEARS: 'deposit_years',
    CHOOSE_PRODUCT: 'deposit_choose_product',
    SHOW_MORE: 'deposit_show_more',
    SHOW_LESS: 'deposit_show_less',
    FEATURES: 'deposit_features',
    SCHEDULE_TRANSFER: 'deposit_scheduled_transfer',
  },
  TERM_DEPOSITS_DETAILS_KEYS: {
    ACCOUNT_DESCRIPTION: 'deposits_termDeposits_details_accountDescription',
    brnCode: 'deposits_termDeposits_details_branchCode',
    BEN_CUR: 'deposits_termDeposits_details_bencurrency',
    PROD_CATEGORY: 'deposits_termDeposits_details_prodCategory',
    maturityDate: 'deposits_termDeposits_details_maturityDate',
    TD_AMOUNT: 'deposits_termDeposits_details_tdAmount',
    DEBIT: 'deposits_termDeposits_details_debit',
    MATURITY_AMOUNT: 'deposits_termDeposits_details_maturityAmount',
    ACCOUNT_OPENING_DATE: 'deposits_termDeposits_details_accOpeningDate',
  },
}

export const PAYDAY_LOANS_KEYS = {
  TITLE: 'paydayLoans_title',
  SUBTITLE: 'paydayLoans_subtitle',
  NOT_ELIGIBLE: 'paydayLoans_notEligible',
  ELIGIBLE: 'paydayLoans_eligible',
  APPLY_BUTTON: 'paydayLoans_applyLoan',
  TERMS_AND_CONDITIONS: 'paydayLoans_termsAndConditions',
  ACCEPT: 'paydayLoans_accept',
  CANCEL: 'paydayLoans_cancel',
  SELECT_ACCOUNT: 'paydayLoans_selectAccount',
  LOAN_AMOUNT: 'paydayLoans_loanAmount',
  PURPOSE_OF_LOAN: 'loan_details_purposeOfLoan',
  PURPOSE_OF_LOAN_DETAILS: 'loan_details_purposeOfLoanDetails',
  PROCEED_BUTTON: 'paydayLoans_proceed',
  DUE_DATE: 'paydayLoans_dueDate',
  INTEREST_CHARGE: 'paydayLoans_interestCharge',
  REPAYMENT_DATE: 'paydayLoans_repaymentDate',
  SUCCESS: 'paydayLoans_success',
  CONGRATULATIONS: 'paydayLoans_congratulations',
  OTP: 'paydayLoans_OTP',
  SUBMIT_BUTTON: 'paydayLoans_submit',
  DONE_BUTTON: 'paydayLoans_done',
}

export const VALIDATION_MESSAGES = {
  REQUIRED: 'validationMessages_required',
  MIN_LENGTH: 'validationMessages_minLength',
  NUMBERS: 'validationMessages_numbers',
  SAME: 'validationMessages_same',
  INTEGER: 'validationMessages_integer',
  GREATER_START_DATE: 'validationMessages_greaterThanStartDate',
  EMAIL: 'validationMessages_email',
  MOBILE_NUMBER: 'validationMessages_invalidMobileNumber',
  MOBILE_NUMBER1: 'validationMessages_MobileNumber',
  ACCUNT_NO_REQUIRED: 'validationMessages_account_no_required',
  FORM_DATE_REQUIRED: 'validationMessages_formDate_required',
  FORM_DATE_VALID: 'validationMessages_formDate_valid',
  TO_DATE_REQUIRED: 'validationMessages_toDate_required',
  TO_DATE_VALID: 'validationMessage_toDate_valid',
  TO_DATE: 'validationMessages_toDate',
  FORMAT: 'validationMessages_format',
  REPORT_VALID: 'validMessages_reportName_required',
  AMOUNT_VALID: 'validationMessages_invalidAmount',
  SERVICENO_OR_MOBILENO: 'validation_serviceno',
  SHORT_NAME: 'validation_shortname',
  SHORT_NAME_VALID: 'validation_shortname_valid',
  MERCHANT: 'validation_merchant',
  INVOICE: 'verification_invoice',
  RECIEPT: 'verification_reciept',
  REMARK: 'verification_remarks',
  PRODUCT: 'verification_product',
  AMOUNT: 'verification_amount',
  STUDENT_CLASS: 'validation_student_class_required',
  CUSTOM_REMARKS: 'verification_customremarks',
  IS_REQUIRED: 'verification_isrequired',
  SCHEDULE_PAYMENT: 'verification_schedulepayment',
  SCHEDULE_DATE: 'verification_scheduledate',
  SERVICE_ID: 'verifiation_serviceid',
  REMARK_VALID: 'remark_valid',
  USERNAME: 'username_valid',
  PASSWORD: 'password_valid',
  CHEQUE_NO: 'cheque_no_required',
  CHEQUE_NO_LENGTH: 'cheque_no_length',
  START_CHEQUE_NO: 'start_cheque_no_required',
  END_CHEQUE_NO: 'end_cheque_no_required',
  BILL_NO: 'bill_no_required',
  DOMESTIC_BENEFICIARY_NAME: 'validation_message_domestic_beneficiary_name',
  DOMESTIC_BENEFICIARY_NAME_MIN_MAX: 'validation_message_domestic_beneficiary_name_min_max',
  DOMESTIC_NICK_NAME: 'validation_message_domestic_nick_name',
  DOMESTIC_NICK_NAME_MIN_MAX: 'validation_message_domestic_nick_name_min_max',
  DOMESTIC_ACCOUNT_NUMBER: 'validation_message_domestic_account_no',
  DOMESTIC_ACCOUNT_NUMBER_MIN_MAX: 'validation_message_domestic_account_no_min_max',
  DOMESTIC_CONFIRM_ACCOUNT_NUMBER: 'validation_message_domestic_confirm_account_no',
  DOMESTIC_CONFIRM_ACCOUNT_NUMBER_NOT_MATCH:
    'validation_message_domestic_confirm_account_not_match',
  DOMESTIC_BENEFICIARY_BANK: 'validation_message_domestic_bank',
  DOMESTIC_BENEFICIARY_BRANCH: 'validation_message_domestic_branch',
  DOMESTIC_TRANSFER_LIMIT: 'validation_message_domestic_transfer_limit',
  DOMESTIC_BENEFICIARY_EMAIL: 'validation_message_domestic_beneficiary_email',
  DOMESTIC_BENEFICIARY_EMAIL_PATTERN: 'validation_message_domestic_beneficiary_email_pattern',
  DOMESTIC_BENEFICIARY_MOBILE: 'validation_message_domestic_beneficiary_mobile',

  REGIONAL_BENEFICIARY_NAME: 'validation_message_regional_beneficiary_name',
  REGIONAL_BENEFICIARY_NAME_MIN_MAX: 'validation_message_regional_beneficiary_name_min_max',
  REGIONAL_NICK_NAME: 'validation_message_regional_nick_name',
  REGIONAL_NICK_NAME_MIN_MAX: 'validation_message_regional_nick_name_min_max',
  REGIONAL_ACCOUNT_NUMBER: 'validation_message_regional_account_no',
  REGIONAL_ACCOUNT_NUMBER_MIN_MAX: 'validation_message_regional_account_no_min_max',
  REGIONAL_CONFIRM_ACCOUNT_NUMBER: 'validation_message_regional_confirm_account_no',
  REGIONAL_CONFIRM_ACCOUNT_NUMBER_NOT_MATCH:
    'validation_message_regional_confirm_account_not_match',
  REGIONAL_BENEFICIARY_BANK: 'validation_message_regional_bank',
  REGIONAL_BENEFICIARY_BRANCH: 'validation_message_regional_branch',
  REGIONAL_TRANSFER_LIMIT: 'validation_message_regional_transfer_limit',
  REGIONAL_BENEFICIARY_EMAIL: 'validation_message_regional_beneficiary_email',
  REGIONAL_BENEFICIARY_EMAIL_PATTERN: 'validation_message_regional_beneficiary_email_pattern',
  REGIONAL_BENEFICIARY_MOBILE: 'validation_message_regional_beneficiary_mobile',

  RECEIVER_MOBILE_NO: 'validation_receiver_mobile_no',
  MOBILENO: 'validation_mobile_no',
  MINIUM_CHAR: 'validation_minimum_char',
  VALIDITY: 'validation_validity',
  START_DATE: 'validation_start_date',
  END_DATE: 'validation_end_date',
  END_DATE_START_DATE: 'validation_end_date_start_date',
  MOBILE_NUMBER_REQUIRED: 'validation_mobile_number_required',
  LOAN_AMOUNT: 'validation_loan_amount_required',
  LOAN_PURPOSE: 'validation_loan_purpose_required',
  LOAN_TENURE: 'validation_loan_tenure_required',
  LOAN_TENURE_VALUE: 'validation_loan_tenure_value_required',
  LOAN_SOURCE_INCOME: 'validation_loan_source_income_required',
  LOAN_CURRENCY: 'validation_loan_currency_required',
  LOAN_INCOME_RANGE: 'validation_loan_income_range_required',
  LOAN_AMOUNT_INVALID: 'validation_loan_amount_invalid_required',
  LOAN_TENURE_VALUE_MIN: 'validation_loan_tenure_value_min_required',
  LOAN_SOURCE_ACC_NO: 'validation_loan_source_acc_no_required',
  LOAN_ACCOUNT_NO: 'validation_loan_account_no_required',
  INTERNAL_NICK_NAME: 'validation_message_internal_nick_name',
  INTERNAL_ACCOUNT_NO: 'validation_message_internal_account_no',
  INTERNAL_ACCOUNT_NO_MIN_MAX: 'validation_message_internal_account_no_min_max',
  INTERNAL_CONFIRM_ACCOUNT_NO: 'validation_message_internal_nick_confirm_account_no',
  INTERNAL_CONFIRM_ACCOUNT_NO_NOT_MATCH: 'validation_message_internal_confirm_account_no_not_match',
  INTERNAL_TRANSFER_LIMIT: 'validation_message_internal_transfer_limit',
  INTERNAL_NICK_NAME_VALID: 'validation_message_internal_nick_name_valid',
  PASSWORD_CRITERIA: 'validation_password_criteria',
  FUNDING_ACC_NO: 'validation_message_funding_account_no',
  ACCOUNT_CLASS: 'validation_message_account_class',
  PICK_UP_BRANCH: 'validation_messagge_pick_up_branch',
  NO_OF_LEAVES: 'validation_messagge_no_of_leaves',
  NO_OF_BOOKS: 'validation_message_no_of_books',
  REASON: 'validation_message_reason',
  EFFECTIVE_DATE: 'validation_message_effective_date',
  REQUEST_TYPE: 'validation_message_request_type',
  BANK_NAME: 'validation_message_bank_name',
  TRANSFER_TYPE: 'validation_message_transfer_type',
  NO_IS_REQUIRED: 'validation_message_no_is_required',
  CARD_REQUIRED: 'validation_card_required',
  VALID_NICK_NAME: 'validation_validate_nick_name',
  VALIDITY_VALUE: 'validation_validity_value',
  SCHOOL_BENE_BANK_TYPE: 'validation_message_school_bene_bank_type',
  SCHOOL_BENE_BANK: 'validation_message_school_bene_bank',
  CLASS_NAME: 'validation_message_class_name',
  SCHOOL_NAME: 'validation_message_school_name',
  STUDENT_NAME: 'validation_message_student_name',
  SCHOOL_TERM: 'validation_message_school_term',
  FEES_PURPOSE: 'validation_message_fees_purpose',
  SCHOOL_YEAR: 'validation_message_school_year',
  NO_ACCESS: 'validation_message_no_access',
}

export const ACCOUNT_KEYS = {
  TRANSACTION_TABS_KEYS: {
    LAST_10: 'components_account_transactionTabs_last10',
    MONTHLY: 'components_account_transactionTabs_monthly',
    WEEK: 'components_account_transactionTabs_week',
    WEEKLY: 'components_account_transactionTabs_weekly',
    DAILY: 'components_account_transactionTabs_daily',
    MONTH_MESSAGE: 'components_account_transactionTabs_monthMessage',
    DOWNLOAD_STATEMENT: 'components_download_statement',
    DOWNLOADING: 'components_downloading',
  },
  CALENDAR_CARD_KEYS: {
    CUSTOM_RANGE: 'components_account_calendarCard_customRange',
  },
  ACCOUNT_SELECT_KEYS: {
    TITLE: 'account_selection_title',
    SUBTITLE: 'account_selection_subtitle',
    AVAILABLE_BALANCE: 'account_selection_availableBalance',
    CURRENT_BALANCE: 'account_selection_currentBalance',
  },
  DETAILS_KEYS: {
    TITLE: 'account_details_title',
    brnCode: 'account_details_branchCode',
    CUSTOMER_ID: 'account_details_customerID',
    currency: 'account_details_currency',
    CUSTOMER_NAME: 'account_details_customerName',
    ACCOUNT_TYPE: 'account_details_accountType',
    ACCOUNT_OPENING_DATE: 'account_details_accOpeningDate',
    ACCOUNT_TYPE_DESCRIPTION: 'account_details_acctypeDescription',
    DISTRICT: 'account_details_district',
    BRANCHNAME: 'account_details_branchname',
    HOUSE: 'account_details_house',
    VIEW_STATEMENT: 'account_details_viewStatement',
    AMOUNT: 'account_statementSelect_amount',
    BUTTON: 'account_details_viewStatement_more',
    HIDE: 'account_details_viewStatement_hide',
  },
  STATEMENT_SELECT_KEYS: {
    TITLE: 'account_statementSelect_title',
    REF: 'account_statementSelect_ref',
    REMARKS: 'account_statementSelect_remarks',
    AMOUNT: 'account_statementSelect_amount',
    MESSAGE: 'account_statementSelect_message',
    BUTTON: 'account_statementSelect_button',
    CURRENT_MONTH: 'account_statementSelect_currentMonth',
    CURRENT_PREVIOUS_MONTH: 'account_statementSelect_currentPreviousMonth',
    CURRENT_PREVIOUS_3_MONTHS: 'account_statementSelect_currentPrevious3Months',
  },
  EXPENSE_KEYS: {
    REF_NUMBER: 'account_expense_ref_number',
    NARRATION: 'account_expense_narration',
    SOURCE_ACCOUNT_NUMBER: 'account_expense_source_account_number',
    DESTINATION_ACCOUNT_NUMBER: 'account_expense_dest_account_number',
    INSTRUMENT_CODE: 'account_expense_instrument_code',
    SERIAL_NUMBER: 'account_expense_serial_number',
  },
  CARD_KEYS: {
    TITLE: 'components_account_accountCard_title',
    STANDING_INSTRUCTION_TITLE: 'components_account_accountCard_title_SI',
  },
  TRANSACTION_DETAILS_KEYS: {
    REF: 'components_account_transactionDetails_ref',
    DATE: 'components_account_transactionDetails_date',
    AMOUNT: 'components_account_transactionDetails_amount',
    currency: 'components_account_transactionDetails_currency',
    DEBIT_CREDIT: 'components_account_transactionDetails_debitOrCredit',
    TXN_TYPE: 'components_account_transactionDetails_txnType',
    REMARK: 'components_account_transactionDetails_remark',
    DESCRIPTION: 'components_account_transactionDetails_description',
    FROM: 'components_account_transactionDetails_from',
    TO: 'components_account_transactionDetails_to',
    INSTRUMENT_CODE: 'components_account_transactionDetails_instrumentCode',
    CLOSE: 'components_account_transactionDetails_close',
    BRANCH: 'components_account_transactionDetails_branch',
  },
}

export const AUTH_KEYS = {
  FORGOT_PASSWORD_KEYS: {
    STEPS: {
      STEP1: 'auth_forgotPassword_step1',
      STEP2: 'auth_forgotPassword_step2',
      STEP3: 'auth_forgotPassword_step3',
    },
    RESET_KEYS: {
      TITLE: 'auth_forgotPassword_title',
      SUBTITLE: 'auth_forgotPassword_subtitle',
      NEW_PASSWORD: 'auth_forgotPassword_newPassword',
      CONFIRM_PASSWORD: 'auth_forgotPassword_confirmPassword',
      CAPTCHA: 'auth_forgotPassword_captcha',
      PASSWORD_CRITERIA: 'auth_forgotPassword_passwordCriteria',
      OTP: 'auth_forgotPassword_otp',
      BACK: 'auth_forgotPassword_back',
      LOGIN: 'auth_forgotPassword_login',
      SUBMIT: 'auth_forgotPassword_submit',
    },
    DETAILS_KEYS: {
      ACCOUNT_NUMBER: 'auth_forgotPassword_accountNumber',
      USERNAME: 'auth_forgotPassword_username',
      CODE: 'auth_forgotPassword_code',
      MOBILE_NUMBER: 'auth_forgotPassword_mobileNumber',
      DOB: 'auth_forgotPassword_dob',
      SUBMIT: 'auth_forgotPassword_submit',
      MOBILENO_WITHOUT_COUNTRY_CODE: 'auth_forgotPassword_mobileno_without_countrycode',
    },
    SUCCESS_KEYS: {
      DONE: 'auth_forgotPassword_success_done',
    },
  },
  GET_STARTED_KEYS: {
    TITLE: 'auth_getStarted_title',
    SUBTITLE: 'auth_getStarted_subtitle',
    SUBTITLE_2: 'auth_getStarted_subtitle2',
    SLOGAN_1: 'auth_getStarted_slogan_1',
    SLOGAN_2: 'auth_getStarted_slogan_2',
    SLOGAN_3: 'auth_getStarted_slogan_3',
    SLOGAN_4: 'auth_getStarted_slogan_4',
  },
  LOGIN_CONTAINER_KEYS: {
    LOGIN_KEYS: {
      TITLE: 'auth_loginContainer_login_title',
      SUBTITLE: 'auth_loginContainer_login_subtitle',
      SUBTITLE_2: 'auth_loginContainer_login_subtitle2',
      USERNAME: 'auth_loginContainer_login_username',
      PASSWORD: 'auth_loginContainer_login_password',
      FORGOT_PASSWORD: 'auth_loginContainer_login_forgotPassword',
      LOGIN_BUTTON: 'auth_loginContainer_login_loginButton',
      KICKED_MESSAGE: 'auth_loginContainer_login_kickedMessage',
      LOGIN_TAB: 'auth_loginContainer_login_loginTab',
      SIGN_UP_TAB: 'auth_loginContainer_login_signUpTab',
      NEW_CUSTOMER_TAB: 'auth_loginContainer_login_newCustomerTab',
      BIOMETRIC_LOGIN_TITLE: 'auth_loginContainer_login_biometricLoginTitle',
      BIOMETRIC_LOGIN_SUBTITLE: 'auth_loginContainer_login_biometricLoginSubtitle',
      NOT_REGISTERED: 'auth_loginContainer_login_notRegistered',
      ERROR: 'auth_loginContainer_login_error',
      NOT_SUPPORTED: 'auth_loginContainer_login_notSupported',
      PIN_LOGIN_BUTTON: 'auth_loginContainer_login_pinLoginButton',
      FORGOT_PIN: 'auth_loginContainer_login_forgotPin',
      APP_NAME: 'app_name',
    },
    NEW_CUSTOMER_KEYS: {
      TITLE: 'auth_loginContainer_newCustomer_title',
      SUBTITLE: 'auth_loginContainer_newCustomer_subtitle',
      currency: 'auth_loginContainer_newCustomer_currency',
      ACCOUNT_TYPE: 'auth_loginContainer_newCustomer_accountType',
      DESCRIPTION: 'auth_loginContainer_newCustomer_description',
    },
    SIGN_UP_KEYS: {
      TITLE: 'auth_loginContainer_signUp_title',
      SUBTITLE: 'auth_loginContainer_signUp_subtitle',
      SUBTITLE_2: 'auth_loginContainer_signUp_subtitle_2',
      SUBTITLE_3: 'auth_loginContainer_signUp_subtitle_3',
      ACCOUNT_NUMBER: 'auth_loginContainer_signUp_accountNumber',
      DOB: 'auth_loginContainer_signUp_dob',
      MOBILE_NUMBER: 'auth_loginContainer_signUp_mobileNumber',
      MOBILE_NUMBER_MESSAGE: 'auth_loginContainer_signUp_mobileNumberMessage',
      CODE: 'auth_loginContainer_signUp_code',
      NATIONAL_ID: 'auth_loginContainer_signUp_nationalID',
      BUTTON: 'auth_loginContainer_signUp_button',
      IDENTITY_TYPE: 'auth_loginContainer_signUp_identityType',
      IDENTITY_NO: 'auth_loginContainer_signUp_identityNo',
      DESCRIPTION: 'auth_loginContainer_signUp_description',
      PASSPORT_NO: 'auth_loginContainer_signUp_passportNo',
      VOTER_ID: 'auth_loginContainer_signUp_voterID',
      DRIVING_LICENCE: 'auth_loginContainer_signUp_driving_licence',
    },
    WALLET_CUSTOMER_KEYS: {
      TITLE: 'auth_loginContainer_walletCustomer_title',
      SUBTITLE: 'auth_loginContainer_walletCustomer_subtitle',
      DESCRIPTION: 'auth_loginContainer_walletCustomer_description',
      IDENTITY_TYPE: 'auth_loginContainer_walletCustomer_identity_type',
      IDENTITY_NUMBER: 'auth_loginContainer_walletCustomer_identity_number',
      ISSUE_DATE: 'auth_loginContainer_walletCustomer_issue_date',
      EXPIRY_DATE: 'auth_loginContainer_walletCustomer_expiry_date',
      COUNTRY_OF_ISSUE: 'auth_loginContainer_walletCustomer_country_of_issue',
      TITLE_FIELD: 'auth_loginContainer_walletCustomer_title_field',
      FIRST_NAME: 'auth_loginContainer_walletCustomer_first_name',
      MIDDLE_NAME: 'auth_loginContainer_walletCustomer_middle_name',
      LAST_NAME: 'auth_loginContainer_walletCustomer_last_name',
      MARITAL_STATUS: 'auth_loginContainer_walletCustomer_marital_status',
      DATE_OF_BIRTH: 'auth_loginContainer_walletCustomer_date_of_birth',
      PLACE_OF_BIRTH: 'auth_loginContainer_walletCustomer_place_of_birth',
      NATIONALITY: 'auth_loginContainer_walletCustomer_nationality',
      COUNTRY_CODE: 'auth_loginContainer_walletCustomer_country_code',
      PHONE_NUMBER: 'auth_loginContainer_walletCustomer_phone_number',
      EMAIL_ID: 'auth_loginContainer_walletCustomer_email_id',
      HOUSE_NUMBER: 'auth_loginContainer_walletCustomer_house_number',
      STREET_LOCALITY_AREA: 'auth_loginContainer_walletCustomer_street_locality_area',
      REGION: 'auth_loginContainer_walletCustomer_region',
      DISTRICT: 'auth_loginContainer_walletCustomer_district',
      OCCUPATION: 'auth_loginContainer_walletCustomer_occupation',
      AGE_GROUP: 'auth_loginContainer_walletCustomer_age_group',
      EMPLOYMENT_TYPE: 'auth_loginContainer_walletCustomer_employment_type',
      SOURCE_OF_INCOME: 'auth_loginContainer_walletCustomer_source_of_income',
      INCOME_RANGE: 'auth_loginContainer_walletCustomer_income_range',
      HOW_KNOW_OUR_BANK: 'auth_loginContainer_walletCustomer_how_know_our_bank',
      UPLOAD_ID_PROOF_FRONT: 'auth_loginContainer_walletCustomer_upload_id_proof_front',
      UPLOAD_ID_PROOF_BACK: 'auth_loginContainer_walletCustomer_upload_id_proof_back',
      UPLOAD_RESIDENCE_ADDRESS_PROOF:
        'auth_loginContainer_walletCustomer_upload_residence_address_proof',
      UPLOAD_PROFILE_IMAGE: 'auth_loginContainer_walletCustomer_upload_profile_image',
      UPLOAD_SELFIE: 'auth_loginContainer_walletCustomer_upload_selfie',
      SIGNATURE_UPLOAD: 'auth_loginContainer_walletCustomer_signature_upload',
      TERMS_CONDITIONS: 'auth_loginContainer_walletCustomer_terms_conditions',
      CONFIRM_DETAILS: 'auth_loginContainer_walletCustomer_confirm_details',
      CONGRATULATIONS: 'auth_loginContainer_walletCustomer_congratulations',
      UPLOAD: 'auth_loginContainer_walletCustomer_upload',
      PROOFS: 'auth_loginContainer_walletCustomer_proofs',
      VALIDATION_IDENTITY_TYPE: 'validation_walletCustomer_identity_type',
      VALIDATION_IDENTITY_NUMBER: 'validation_walletCustomer_identity_number',
      VALIDATION_ISSUE_DATE: 'validation_walletCustomer_issue_date',
      VALIDATION_EXPIRY_DATE: 'validation_walletCustomer_expiry_date',
      VALIDATION_COUNTRY_OF_ISSUE: 'validation_walletCustomer_country_of_issue',
      VALIDATION_TITLE_FIELD: 'validation_walletCustomer_title_field',
      VALIDATION_FIRST_NAME: 'validation_walletCustomer_first_name',
      VALIDATION_LAST_NAME: 'validation_walletCustomer_last_name',
      VALIDATION_MARITAL_STATUS: 'validation_walletCustomer_marital_status',
      VALIDATION_DATE_OF_BIRTH: 'validation_walletCustomer_date_of_birth',
      VALIDATION_PLACE_OF_BIRTH: 'validation_walletCustomer_place_of_birth',
      VALIDATION_NATIONALITY: 'avalidation_walletCustomer_nationality',
      VALIDATION_COUNTRY_CODE: 'validation_walletCustomer_country_code',
      VALIDATION_PHONE_NUMBER: 'validation_walletCustomer_phone_number',
      VALIDATION_EMAIL_ID: 'validation_walletCustomer_email_id',
      VALIDATION_HOUSE_NUMBER: 'validation_walletCustomer_house_number',
      VALIDATION_STREET_LOCALITY_AREA: 'validation_walletCustomer_street_locality_area',
      VALIDATION_REGION: 'validation_walletCustomer_region',
      VALIDATION_EMPLOYMENT_TYPE: 'validation_walletCustomer_employment_type',
      VALIDATION_SOURCE_OF_INCOME: 'validation_walletCustomer_source_of_income',
      VALIDATION_INCOME_RANGE: 'validation_walletCustomer_income_range',
      TERM_CONDITIONS_TEXT: 'auth_loginContainer_walletCustomer_terms_condition',
      VALIDATION_INVALID_EMAIL_ID: 'validation_walletCustomer_invalid_email_id',
    },
  },
  NEW_CUSTOMER_KEYS: {
    TITLE: 'auth_newCustomer_title',
    SUBTITLE: 'auth_newCustomer_subtitle',
    DETAILS_KEYS: {
      CUSTOMER_INFO: 'auth_newCustomer_details_customerInfo',
      FIRST_NAME: 'auth_newCustomer_details_firstName',
      MIDDLE_NAME: 'auth_newCustomer_details_middleName',
      LAST_NAME: 'auth_newCustomer_details_lastName',
      DOB: 'auth_newCustomer_details_dob',
      PLACE_OF_BIRTH: 'auth_newCustomer_details_placeOfBirth',
      BIRTH_COUNTRY: 'auth_newCustomer_details_birthCountry',
      MARITAL_STATUS: 'auth_newCustomer_details_maritalStatus',
      NATIONALITY: 'auth_newCustomer_details_nationality',
      IDENTITY_TYPE: 'auth_newCustomer_details_identityType',
      IDENTITY_NUMBER: 'auth_newCustomer_details_identityNumber',
      ISSUE_DATE: 'auth_newCustomer_details_issueDate',
      ISSUE_COUNTRY: 'auth_newCustomer_details_issueCountry',
      EXPIRY_DATE: 'auth_newCustomer_details_expiryDate',
      TAX_ID: 'auth_newCustomer_details_taxID',
      SUBMIT: 'auth_newCustomer_details_submit',
    },
    ID_KEYS: {
      TITLE: 'auth_newCustomer_id_title',
      SUBTITLE: 'auth_newCustomer_id_subtitle',
      SUBTITLE_2: 'auth_newCustomer_id_subtitle2',
      PICK_IMAGE: 'auth_newCustomer_id_pickImage',
      PICK_IMAGE_2: 'auth_newCustomer_id_pickImage2',
      CONTINUE: 'auth_newCustomer_id_continue',
    },
    IMAGE_KEYS: {
      PICK_IMAGE: 'auth_newCustomer_image_pickImage',
      CAMERA: 'auth_newCustomer_image_camera',
      CONTINUE: 'auth_newCustomer_image_continue',
    },
    MORE_DETAILS_KEYS: {
      TITLE: 'auth_newCustomer_moreDetails_title',
      CODE: 'auth_newCustomer_moreDetails_code',
      MOBILE_NUMBER: 'auth_newCustomer_moreDetails_mobileNumber',
      EMAIL_ID: 'auth_newCustomer_moreDetails_emailId',
      HOUSE: 'auth_newCustomer_moreDetails_house',
      STREET: 'auth_newCustomer_moreDetails_street',
      CITY: 'auth_newCustomer_moreDetails_city',
      DISTRICT: 'auth_newCustomer_moreDetails_district',
      CHIEF: 'auth_newCustomer_moreDetails_chief',
      VILLAGE: 'auth_newCustomer_moreDetails_village',
      EMPLOYMENT_TYPE: 'auth_newCustomer_moreDetails_employmentType',
      SOURCE_OF_INCOME: 'auth_newCustomer_moreDetails_sourceOfIncome',
      INCOME_RANGE: 'auth_newCustomer_moreDetails_incomeRange',
      BUTTON: 'auth_newCustomer_moreDetails_button',
    },
    SUCCESS_KEYS: {
      TITLE: 'auth_newCustomer_success_title',
      BUTTON: 'auth_newCustomer_success_button',
    },
  },
  OTP_KEYS: {
    TITLE: 'auth_otp_title',
    SUBTITLE: 'auth_otp_subtitle',
    BUTTON: 'auth_otp_button',
  },
  TERMS_AND_CONDITIONS_KEYS: {
    TITLE: 'auth_termsAndConditions_title',
    SUBTITLE: 'auth_termsAndConditions_subtitle',
    BUTTON: 'auth_termsAndConditions_button',
    CANCEL: 'auth_termsAndConditions_cancel',
  },
  SIGN_UP_KEYS: {
    TITLE: 'auth_signup_title',
    REQUEST_VALUE: {
      RELATIONSHIP_TYPE: 'auth_signUp_request_relationshipType',
      CUSTOMER_IDENTITY: 'auth_signUp_request_customerId',
      SOURCE_OF_INCOME: 'auth_signUp_request_sourceOfIncome',
      EMPLOYMENT_TYPE: 'auth_signUp_request_employementInfo',
      BANK_OR_PRODUCT: 'auth_signUp_request_bankOrProduct',
      INCOME_RANGE: 'auth_signUp_request_incomeRange',
      ACCOUNT_TYPE: 'auth_signUp_request_accountType',
      MARITUAL_STATUS: 'auth_signUp_request_maritualStatus',
      ACCOUNT_CURRENCY: 'auth_signUp_request_accountCurrency',
      CUSTOMER_INFO: 'auth_signUp_request_customerInfo',
      PURPOSE_OF_ACCOUNT: 'auth_signUp_request_purposeOfAccount',
      ADDITIONAL_SERVICE: 'auth_signUp_request_additionalService',
      CUSTOMER_ID_PASSPORT: 'auth_signUp_request_customerID_passport',
      CUSTOMER_ID_NATIONAL_ID: 'auth_signUp_request_customerID_nationalId',
    },
    DETAILS_KEYS: {
      TITLE: 'auth_signUp_details_title',
      SUBTITLE: 'auth_signUp_details_subtitle',
      USERNAME: 'auth_signUp_details_username',
      PASSWORD: 'auth_signUp_details_password',
      CONFIRM_PASSWORD: 'auth_signUp_details_confirmPassword',
      PASSWORD_CRITERIA: 'auth_signUp_details_passwordCriteria',
      BUTTON: 'auth_signUp_details_button',
    },
    SUCCESS_KEYS: {
      BUTTON: 'auth_signUp_success_title',
    },
  },
}

export const DIALOG_KEYS = {
  CLOSE: 'dashboard_OKButton',
  YES: 'profile_yes',
  NO: 'profile_no',
  DONE: 'dashboard_OKButton',
  LAST_LOGIN: 'dashboard_lastLogin',
  INFORMATION: 'dashboard_information',
  NO_NOTIFICATION: 'no_notification',
  NO_ACCOUNTS: 'no_accounts',
  NO_LOANS: 'no_loans',
  NO_CHEQUE_BOOK_STATUS: 'no_chequeBook_status',
  NO_DEPOSITS: 'no_deposits',
  NO_ACCESS: 'no_access',
  NO_STATEMENT: 'No_statement',
  NO_TRANSACTION: 'no_transaction',
  CONFIRM_YES: 'confirm_yes',
  CONFIRM_NO: 'confirm_no',
  CHOOSE_PRODUCT: 'choose_product',
  DEBIT_CREDIT_NOT_SAME: 'credit_debit_not_same',
  DELETE_IMAGE: 'delete_image',
  CANCEL_MESSAGE: 'cancel_message',
  CANCEL: 'dialog_cancel',
  OTP_MESSAGE: 'otp_message',
  SUBMIT: 'dialog_submit',
  ENTER_OTP: 'components_base_otp_title',
  OK: 'dialog_ok',
  NEXT: 'next_button',
  BACK: 'back_button',
  CLEAR: 'clear_button',
  SAVE: 'save_button',
}

export const KEYBOARD_DIALOG = {
  SUBMIT: 'keyboard_submit',
  CLEAR: 'keyboard_clear',
  ERROR_PLACEHOLDER: 'Error_Placeholder',
  SOMETHING: 'something',
  CUSTOM: 'custom',
  CLOSE: 'keyboard_close',
}

export const ADD_BENEFICIARY = {
  DOMESTIC: {
    BENEFICIARY_NAME: 'add_beneficiary_domestic_beneficiary_name',
    NICK_NAME: 'add_beneficiary_domestic_nick_name',
    ACCOUNT_NUMBER: 'add_beneficiary_domestic_account_no',
    CONFIRM_ACCOUNT_NUMBER: 'add_beneficiary_domestic_confirm_account_no',
    BENEFICIARY_BANK: 'add_beneficiary_domestic_bank',
    BENEFICIARY_BRANCH: 'add_beneficiary_domestic_branch',
    TRANSFER_LIMIT: 'add_beneficiary_domestic_transfer_limit',
    BENEFICIARY_EMAIL: 'add_beneficiary_domestic_beneficiary_email',
    BENEFICIARY_MOBILE: 'add_beneficiary_domestic_beneficiary_mobile',
  },
  CONFIRM: 'add_beneficiary_confirm_btn',
  SUBMIT: 'add_beneficiary_submit_btn',
}

export const BENEFICIARY_TRANSFER_KEYS = {
  TRANSFER_LIMIT_TXT: 'transfer_limit_txt',
  BENEFICIARY_TRANSFER: {
    TITLE: 'beneficiaryTransfer_title',
    SUBTITLE: 'beneficiaryTransfer_subtitle',
    BENE_TRANSFER_TITLE: 'beneficiaryTransfer_bene_transfer_title',
    WITH_IN_BANK: 'beneficiaryTransfer_with_in_bank',
    DOMESTIC: 'beneficiaryTransfer_domestic',
    INTERNATIONAL: 'beneficiaryTransfer_international',
    MY_ACCOUNT: 'beneficiaryTransfer_my_account',
    ADD_NEW: 'beneficiaryTransfer_add_new',
    SEARCH: 'beneficiaryTransfer_search',
    NO_ACCOUNT: 'beneficiaryTransfer_no_account',
    INTERNAL_TRANSFER_TITLE: 'beneficiaryTransfer_internal_transfer_title',
    HAS_FX_DEAL: 'beneficiaryTransfer_has_fx_deal',
    FX_REF_NO: 'beneficiaryTransfer_fx_ref_no',
    YES: 'beneficiaryTransfer_yes',
    NO: 'beneficiaryTransfer_no',
    SENDER_TO_RECEIVER: 'beneficiaryTransfer_sender_to_receiver',
    INTERNATIONAL_TRANSFER_TITLE: 'beneficiaryTransfer_international_transfer_title',
    DOMESTIC_TRANSFER_TITLE: 'beneficiaryTransfer_domestic_transfer_title',
    OWN_TRANSFER_TITLE: 'beneficiaryTransfer_own_transfer_title',
    VIEW_BENEFICIARIES_TITLE: 'beneficiaryTransfer_view_beneficiary_title',
    REGIONAL_TRANSFER_TITLE: 'beneficiaryTransfer_regional_transfer_title',
    REGIONAL: 'beneficiaryTransfer_regional',
  },

  ADD_BENEFICIARY_BANK_KEYS: {
    TITLE: 'beneficiaryTransfer_addBeneficiary_title',
    NOTE: 'note',
    SUBTITLE: 'beneficiaryTransfer_addBeneficiary_subtitle',
    ADDDOMESTIC: 'beneficiaryTransfer_addBeneficiary_adddomesic',
    ADDINTERNAL: 'beneficiaryTransfer_addBeneficiary_addInternal',
    ADDINTERNATIONAL: 'beneficiaryTransfer_addBeneficiary_addinternatinal',
    MODIFYDOMESTIC: 'beneficiaryTransfer_addBeneficiary_modifydomesic',
    MODIFYINTERNAL: 'beneficiaryTransfer_addBeneficiary_modifyinternal',
    MODIFYINTERNATIONAL: 'beneficiaryTransfer_addBeneficiary_modifyinternational',
    CONFIRMDOMESTIC: 'beneficiaryTransfer_addBeneficiary_confirmdomestic',
    CONFIRMINTERNAL: 'beneficiaryTransfer_addBeneficiary_confirmInternal',
    CONFIRMINTERNATIONAL: 'beneficiaryTransfer_addBeneficiary_confirminternational',
    REPEAT: 'beneficiaryTransfer_addBeneficiary_repeat',
    NICK_NAME: 'beneficiaryTransfer_addBeneficiary_nickName',
    NICK_NAME1: 'beneficiaryTransfer_addBeneficiary_nickName1',
    NAME: 'beneficiaryTransfer_addBeneficiary_name',
    NAME1: 'beneficiaryTransfer_addBeneficiary_name1',
    ACCOUNT_NUMBER: 'beneficiaryTransfer_addBeneficiary_accountNumber',
    ACCOUNT_NUMBER1: 'beneficiaryTransfer_addBeneficiary_accountNumber1',
    CONFIRM_ACCOUNT_NUMBER: 'beneficiaryTransfer_addBeneficiary_confirmAccountNumber',
    BANK: 'beneficiaryTransfer_addBeneficiary_bank',
    BANK1: 'beneficiaryTransfer_addBeneficiary_bank1',
    BRANCH: 'beneficiaryTransfer_addBeneficiary_branch',
    BRANCH1: 'beneficiaryTransfer_addBeneficiary_branch1',
    TRANSFER_LIMIT: 'beneficiaryTransfer_addBeneficiary_transferLimit',
    TRANSFER_LIMIT1: 'beneficiaryTransfer_addBeneficiary_transferLimit1',
    SUBMIT: 'beneficiaryTransfer_addBeneficiary_submit',
    BENE_ADDRESS: 'beneficiaryTransfer_addBeneficiary_beneAddress',
    BENE_COUNTRY: 'beneficiaryTransfer_addBeneficiary_beneCountry',
    MODE_OF_TRANSFER: 'beneficiaryTransfer_addBeneficiary_ModeofTransfer',
    BENE_ADDRESS1: 'beneficiaryTransfer_addBeneficiary_beneAddress1',
    BENE_COUNTRY1: 'beneficiaryTransfer_addBeneficiary_beneCountry1',
    MODE_OF_TRANSFER1: 'beneficiaryTransfer_addBeneficiary_ModeofTransfer1',
    CODE: 'beneficiaryTransfer_addBeneficiary_code',
    BANK_ADDRESS: 'beneficiaryTransfer_addBeneficiary_bankAddress',
    BANK_COUNTRY: 'beneficiaryTransfer_addBeneficiary_bankCountry',
    BANK_ADDRESS1: 'beneficiaryTransfer_addBeneficiary_bankAddress1',
    BANK_COUNTRY1: 'beneficiaryTransfer_addBeneficiary_bankCountry1',
    BENE_MOBILE: 'beneficiaryTransfer_addBeneficiary_mobile',
    BENE_EMAIL: 'beneficiaryTransfer_addBeneficiary_email',
    BENE_MOBILE1: 'beneficiaryTransfer_addBeneficiary_mobile1',
    BENE_EMAIL1: 'beneficiaryTransfer_addBeneficiary_email1',
    INSTANTTRANSFER: 'quickPay_select_instantTransfer',
    CONFIRMINSTANTTRANSFER: 'quickPay_select_confirminstantTransfer',
    QUICKPAY_BANK: 'quickPay_confirm_bankName',
    QUICKPAY_BRANCH: 'quickPay_instantTransfer_branch',
    BIC: 'quickPay_instantTransfer_bic',
    SORT: 'quickPay_instantTransfer_sort',
    ADD_AS_BENEFICIARY: 'quickPay_instantTransfer_addAsBeneficiary',
    ACCOUNT_TYPE: 'quickPay_instantTransfer_accountType',
    BEN_ACCOUNT: 'quickPay_instantTransfer_benaccount',
    BEN_CURRENCY: 'quickPay_instantTransfer_bencurrency',
    BEN_BRANCH: 'quickPay_instantTransfer_benbranch',
    INTERNAL: 'quickPay_instant_transfer_iat',
    DDACC_TRANSFER: 'quickPay_instant_transfer_ddacc',
    RTGS_TRANSFER: 'quickPay_instant_transfer_rtgs',
    QUICKPAY_BRANCH_NAME: 'quickPay_branch_name',
    QUICKPAY_BANK_NAME: 'quickPay_bankName',
    QUICKPAY_CHARGE: 'quickPay_charge',
    INTERNAL_ACCOUNT_NO: 'addBeneficiary_account_no',
    INTERNAL_CONFIRM_ACCOUNT_NO: 'addBeneficiary_confirm_account_no',
    ADDREGIONAL: 'beneficiaryTransfer_addBeneficiary_addregional',
    CONFIRMREGIONAL: 'beneficiaryTransfer_addBeneficiary_confirmRegional',
    MODIFYREGIONAL: 'beneficiaryTransfer_addBeneficiary_modifyRegional',
    REGIONAL: 'quickPay_instant_transfer_regional',
  },
  ADD_BENEFICIARY_SELECT_KEYS: {
    INTERNAL_ACCOUNT_TITLE: 'beneficiaryTransfer_addBeneficiarySelect_internalAccountTitle',
    INTERNAL_ACCOUNT_SUBTITLE: 'beneficiaryTransfer_addBeneficiarySelect_internalAccountSubtitle',
    OTHER_BANK_ACCOUNT_TITLE: 'beneficiaryTransfer_addBeneficiarySelect_otherBankAccountTitle',
    OTHER_BANK_ACCOUNT_SUBTITLE:
      'beneficiaryTransfer_addBeneficiarySelect_otherBankAccountSubtitle',
    MY_ACCOUNT: 'beneficiaryTransfer_addBeneficiarySelect_myAccountTitle',
  },
  ADD_BENEFICIARY_SUCCESS_KEYS: {
    TITLE: 'beneficiaryTransfer_addBeneficiary_title',
    SUBTITLE: 'beneficiaryTransfer_addBeneficiary_subtitle',
    DONE: 'beneficiaryTransfer_addBeneficiary_done',
  },
  BENEFICIARY_DETAILS_KEYS: {
    TITLE: 'beneficiaryTransfer_beneficiaryDetails_title',
    SUBTITLE: 'beneficiaryTransfer_beneficiaryDetails_subtitle',
    EDIT: 'beneficiaryTransfer_beneficiaryDetails_edit',
    BENEFICIARY_IMAGE: 'beneficiaryTransfer_beneficiaryDetails_image',
    BENEFICIARY_DELETE: 'beneficiaryTransfer_beneficiaryDetails_deleteBenficiary',
    CAMERA: 'beneficiaryTransfer_beneficiaryDetails_camera',
    GALLERY: 'beneficiaryTransfer_beneficiaryDetails_gallery',
    DELETE: 'beneficiaryTransfer_beneficiaryDetails_delete',
    DELETE_MESSAGE: 'beneficiaryTransfer_beneficiaryDetails_deleteMessage',
    YES: 'beneficiaryTransfer_beneficiaryDetails_yes',
    CANCEL: 'beneficiaryTransfer_beneficiaryDetails_cancel',
    NAME: 'beneficiaryTransfer_beneficiaryDetails_name',
    NICK_NAME: 'beneficiaryTransfer_beneficiaryDetails_nickName',
    BENE_TYPE: 'beneficiaryTransfer_beneficiaryDetails_benetype',
    ACCOUNT_NUMBER: 'beneficiaryTransfer_beneficiaryDetails_accountNumber',
    TRANSFER_LIMIT: 'beneficiaryTransfer_beneficiaryDetails_transferLimit',
    REMOVE: 'beneficiaryTransfer_beneficiaryDetails_remove',
    BANK_NAME: 'beneficiaryTransfer_beneficiaryEdit_bankName',
    brnName: 'beneficiaryTransfer_beneficiaryEdit_branchName',
    EDIT_BEN: 'beneficiaryTransfer_edit',
    MAKE_PAYMENT: 'beneficiaryTransfer_makepayment',
    INTERNAL: 'beneficiaryTransfer_beneficiaryDetails_internal',
    OTHER: 'beneficiaryTransfer_beneficiaryDetails_other',
    INTERNATIONAL: 'beneficiaryTransfer_beneficiaryDetails_international',
  },
  BENEFICIARY_EDIT_KEYS: {
    TITLE: 'beneficiaryTransfer_beneficiaryEdit_title',
    SUBTITLE: 'beneficiaryTransfer_beneficiaryEdit_subtitle',
    NAME: 'beneficiaryTransfer_beneficiaryEdit_name',
    NICK_NAME: 'beneficiaryTransfer_beneficiaryEdit_nickName',
    ACCOUNT_NUMBER: 'beneficiaryTransfer_beneficiaryEdit_accountNumber',
    TRANSFER_LIMIT: 'beneficiaryTransfer_beneficiaryEdit_transferLimit',
    BANK_NAME: 'beneficiaryTransfer_beneficiaryEdit_bankName',
    brnName: 'beneficiaryTransfer_beneficiaryEdit_branchName',
    SUBMIT: 'beneficiaryTransfer_beneficiaryEdit_submit',
  },
  SELECT_KEYS: {
    TITLE: 'beneficiaryTransfer_beneficiarySelect_title',
    SUBTITLE: 'beneficiaryTransfer_beneficiarySelect_subtitle',
    OWN_ACCOUNT: 'beneficiaryTransfer_beneficiarySelect_ownAccount',
    THIRD_PARTY: 'beneficiaryTransfer_beneficiarySelect_thirdParty',
    INTERNAL: 'beneficiaryTransfer_beneficiarySelect_internal',
  },
  TERMS_AND_CONDITIONS_KEYS: {
    TITLE: 'beneficiaryTransfer_termsAndConditions_title',
    ACCEPT: 'beneficiaryTransfer_termsAndConditions_accept',
  },
  TRANSFER_DETAILS_KEYS: {
    TITLE: 'beneficiaryTransfer_transferDetails_title',
    SUBTITLE: 'beneficiaryTransfer_transferDetails_subtitle',
    TRANSFER_TYPE: 'beneficiaryTransfer_transferDetails_transferType',
    AMOUNT: 'beneficiaryTransfer_transferDetails_amount',
    RTGS: 'beneficiaryTransfer_transferDetails_rtgs',
    DDACC: 'beneficiaryTransfer_transferDetails_ddacc',
    SWIFT: 'beneficiaryTransfer_transferDetails_swift',
    DESCRIPTION: 'beneficiaryTransfer_transferDetails_description',
    T_C: 'beneficiaryTransfer_transferDetails_termsAndConditions',
    SUBMIT: 'beneficiaryTransfer_transferDetails_submit',
  },
  TRANSFER_CONFIRM_KEYS: {
    SOURCE_ACCOUNT_NUMBER: 'beneficiaryTransfer_transferConfirm_sourceAccountNumber',
    currency: 'beneficiaryTransfer_transferConfirm_currency',
    RECEIVER_NAME: 'beneficiaryTransfer_transferConfirm_receiverName',
    RECEIVER_ACCOUNT_NUMBER: 'beneficiaryTransfer_transferConfirm_receiverAccountNumber',
    DESCRIPTION: 'beneficiaryTransfer_transferConfirm_description',
    TRANSFER_AMOUNT: 'beneficiaryTransfer_transferConfirm_transferAmount',
    TRANSFER_AMOUNT1: 'beneficiaryTransfer_transferConfirm_transferAmount1',
    RESEND_OTP: 'beneficiaryTransfer_transferConfirm_resendOTP',
    CONFIRM: 'beneficiaryTransfer_transferConfirm_confirm',
    CHARGES: 'beneficiaryTransfer_transferConfirm_charges',
  },
  TRANSFER_OTP_KEYS: {
    TITLE: 'beneficiaryTransfer_transferOTP_title',
    SUBTITLE: 'beneficiaryTransfer_transferOTP_subtitle',
    CANCEL: 'beneficiaryTransfer_transferOTP_cancel',
    SUBMIT: 'beneficiaryTransfer_transferOTP_submit',
  },
  TRANSFER_SUCCESS_KEYS: {
    TITLE: 'beneficiaryTransfer_transferSuccess_title',
    SUBTITLE: 'beneficiaryTransfer_transferSuccess_subtitle',
    SAVE_RECEIPT: 'beneficiaryTransfer_transferSuccess_saveReceipt',
    DONE: 'beneficiaryTransfer_transferSuccess_done',
    SEND_TO_WALLET: 'beneficiaryTransfer_sendtowallet',
    CONFIRM_WALLET: 'beneficiaryTransfer_confirmwallet',
  },
}

export const REQUESTS_KEYS = {
  TERMS_AND_CONDITIONS_KEYS: {
    TITLE: 'requests_termsAndConditions_title',
    ACCEPT: 'requests_termsAndConditions_accept',
  },
  SELECT_REQUEST_KEYS: {
    TITLE: 'requests_select_title',
    SUBTITLE: 'requests_select_subtitle',
    CHEQUE_TITLE: 'requests_select_chequeTitle',
    CHEQUE_SUBTITLE: 'requests_select_chequeSubtitle',
    STANDING_INSTRUCTION_TITLE: 'requests_select_standingInstructionTitle',
    STANDING_INSTRUCTION_SUBTITLE: 'requests_select_standingInstructionSubtitle',
    DEBIT_CARD_TITLE: 'requests_select_debitCardTitle',
    DEBIT_CARD_SUBTITLE: 'requests_select_debitCardSubtitle',
    SHORT_NAME: 'request_shortName',
    ERROR: 'error',
  },
  CHEQUE_KEYS: {
    TITLE: 'requests_cheque_title',
    SUBTITLE: 'requests_cheque_subtitle',
    CHEQUE_BOOK: 'requests_cheque_chequeBook',
    STOP_CHEQUE_PAYMENT: 'requests_cheque_stopChequePayment',
    CHECK_STATUS: 'requests_cheque_chequeStatus',
    CHEQUE_BOOK_KEYS: {
      TITLE: 'requests_cheque_book_title',
      SUBTITLE: 'requests_cheque_book_subtitle',
      ACCOUNT_NUMBER: 'requests_cheque_book_accountNumber',
      PICK_UP_BRANCH: 'requests_cheque_book_pickUpBranch',
      NO_OF_LEAVES: 'requests_cheque_book_noOfLeaves',
      NO_OF_BOOKS: 'requests_cheque_book_noOfBooks',
      PICK_UP_BRANCH1: 'requests_cheque_book_pickUpBranch1',
      NO_OF_LEAVES1: 'requests_cheque_book_noOfLeaves1',
      T_C: 'requests_cheque_book_termsAndConditions',
      T_C_ACCEPT: 'requests_cheque_book_termsAndConditionsAccept',
      SUBMIT: 'requests_cheque_book_submit',
      CONFIRM: 'requests_cheque_book_confirm',
      DONE: 'requests_cheque_book_done',
    },
    CHEQUE_STATUS_KEYS: {
      TITLE: 'requests_cheque_status_title',
      CHEQUE: 'requests_cheque_status_cheque',
      CHECK_STATUS: 'requests_cheque_status_chequestatus',
      SUBTITLE: 'requests_cheque_status_subtitle',
      ACCOUNT_NUMBER: 'requests_cheque_status_accountNumber',
      SERVICE_ID: 'requests_cheque_status_serviceId',
      CHEQUE_NUMBER: 'requests_cheque_status_chequeNumber',
      SUBMIT: 'requests_cheque_status_submit',
      CONFIRM: 'requests_cheque_status_confirm',
      status: 'requests_cheque_status_status',
    },

    CHEQUE_BOOK_STATUS_KEYS: {
      TITLE: 'requests_cheque_book_status_title',
      SUBTITLE: 'requests_cheque_book_status_subtitle',
      ACCOUNT_NUMBER: 'requests_cheque_book_status_accountNumber',
      STATUS: 'requests_cheque_book_status_status',
      NO_OF_CHEQUE_BOOKS: 'requests_cheque_book_status_noOfChequeBooks',
      NO_OF_LEAVES: 'requests_cheque_book_status_noOfLeaves',
      BRANCH_CODE: 'requests_cheque_book_status_branchCode',
      REQUESTED_DATE: 'requests_cheque_book_status_requested_date',
      CURRENCY: 'requests_cheque_book_status_currency',
    },
    STOP_CHEQUE_PAYMENT_KEYS: {
      TITLE: 'requests_cheque_stopChequePayment_title',
      PAY: 'requests_cheque_stopChequePayment_pay',
      SUBTITLE: 'requests_cheque_stopChequePayment_subtitle',
      ACCOUNT_NUMBER: 'requests_cheque_stopChequePayment_accountNumber',
      REQUEST_TYPE: 'requests_cheque_stopChequePayment_requestType',
      INDIVIDUAL: 'requests_cheque_stopChequePayment_individual',
      RANGE: 'requests_cheque_stopChequePayment_range',
      START_CHEQUE_NUMBER: 'requests_cheque_stopChequePayment_startChequeNumber',
      END_CHEQUE_NUMBER: 'requests_cheque_stopChequePayment_endChequeNumber',
      EFFECTIVE_DATE: 'requests_cheque_stopChequePayment_effectiveDate',
      START_CHEQUE_NUMBER1: 'requests_cheque_stopChequePayment_startChequeNumber1',
      END_CHEQUE_NUMBER1: 'requests_cheque_stopChequePayment_endChequeNumber1',
      EFFECTIVE_DATE1: 'requests_cheque_stopChequePayment_effectiveDate1',
      REASON: 'requests_cheque_stopChequePayment_reason',
      REASON1: 'requests_cheque_stopChequePayment_reason1',
      LOST: 'requests_cheque_stopChequePayment_lost',
      STOLEN: 'requests_cheque_stopChequePayment_stolen',
      OTHER: 'requests_cheque_stopChequePayment_other',
      SUBMIT: 'requests_cheque_stopChequePayment_submit',
      REMARKS: 'requests_cheque_stopChequePayment_remarks',
      REMARKS1: 'requests_cheque_stopChequePayment_remarks1',
      CONFIRM: 'requests_cheque_stopChequePayment_confirm',
      status: 'requests_cheque_stopChequePayment_status',
      DONE: 'requests_cheque_stopChequePayment_done',
      ACCOUNTNO: 'requests_cheque_stopChequePayment_accountno',
      DATE_ON_CHECK: 'requests_cheque_stopChequePayment_dateoncheck',
      BENEFICIARY_ACCOUNT: 'requests_cheque_stopChequePayment_beneAccountno',
      UTILIZED: 'requests_cheque_stopChequePayment_utilized',
      NOT_UTILIZED: 'requests_cheque_stopChequePayment_notutilized',
      REJECT: 'requests_cheque_stopChequePayment_reject',
      STOPPED: 'requests_cheque_stopChequePayment_stopped',
    },
  },
  STANDING_INSTRUCTION_KEYS: {
    TITLE: 'requests_standingInstruction_title',
    SUBTITLE: 'requests_standingInstruction_subtitle',
    CREATE: 'requests_standingInstruction_create',
    VIEW: 'requests_standingInstruction_view',
    CREATE_SI: 'create_si',
    VIEW_KEYS: {
      REQUEST_TYPE: 'requests_standingInstruction_create_requestType1',
      EXPIRY_DATE: 'requests_standingInstruction_view_expiryDate',
      AMOUNT: 'requests_standingInstruction_view_amount',
      BENEFICIARY_ACCOUNT: 'requests_standingInstruction_view_beneficiaryAccount',
      brnCode: 'requests_standingInstruction_view_branchCode',
      CONTRACT_REF_NO: 'requests_standingInstruction_view_contractRefNo',
      currency: 'requests_standingInstruction_view_currency',
      FREQUENCY: 'requests_standingInstruction_view_frequency',
      SOURCE_ACCOUNT: 'requests_standingInstruction_view_sourceAccount',
      CREDIT_ACCOUNT_DESC: 'requests_standingInstruction_create_creditAccountDesc',
      CLOSE: 'requests_standingInstruction_view_close',
      START_DATE: 'requests_standingInstruction_create_start',
      END_DATE: 'requests_standingInstruction_create_end',
      DAYS: 'requests_standingInstruction_create_day',
      MONTHS: 'requests_standingInstruction_create_month',
      YEARS: 'requests_standingInstruction_create_year',
      REMARKS: 'requests_standingInstruction_create_remark',
      SI_TYPE: 'requests_standingInstruction_view_sitype',
      PROD_CAT: 'requests_standingInstruction_view_prodcat',
      PROD_CODE: 'requests_standingInstruction_view_prodcode',
      NO_SI: 'no_si',
      YES: 'yes',
      NO: 'no',
      DOMESTIC: 'requests_standingInstruction_view_domestic',
      REF_NO: 'requests_standingInstruction_view_ref_no',
      CREDIT_ACCOUNT_NO: 'requests_standingInstruction_credit_account_no',
    },
    CREATE_KEYS: {
      TITLE: 'requests_standingInstruction_create_title',
      SUBTITLE: 'requests_standingInstruction_create_subtitle',
      REQUEST_TYPE: 'requests_standingInstruction_create_requestType',
      INTERNAL: 'requests_standingInstruction_create_internal',
      OWN_ACCOUNT: 'requests_standingInstruction_create_ownAccount',
      DDACC_TRANSFER: 'requests_standingInstruction_create_ddacc_transfer',
      RTGS_TRANSFER: 'requests_standingInstruction_create_rtgs_transfer',
      OTHER_BANK: 'requests_standingInstruction_create_otherBank',
      TRANSFER_TYPE: 'requests_standingInstruction_create_transferType',
      RTGS: 'requests_standingInstruction_create_rtgs',
      DDACC: 'requests_standingInstruction_create_ddacc',
      DEBIT_ACCOUNT_NUMBER: 'requests_standingInstruction_create_debitAccountNumber',
      CREDIT_ACCOUNT_NUMBER: 'requests_standingInstruction_create_creditAccountNumber',
      START_DATE: 'requests_standingInstruction_create_startDate',
      END_DATE: 'requests_standingInstruction_create_endDate',
      DAYS: 'requests_standingInstruction_create_days',
      MONTHS: 'requests_standingInstruction_create_months',
      YEARS: 'requests_standingInstruction_create_years',
      MONTH_END: 'requests_standingInstruction_create_monthEnd',
      BANK: 'requests_standingInstruction_create_bank',
      BRANCH: 'requests_standingInstruction_create_branch',
      BRANCH1: 'requests_standingInstruction_create_branch1',
      SI_AMOUNT: 'requests_standingInstruction_create_siAmount',
      REMARKS: 'requests_standingInstruction_create_remarks',
      SUBMIT: 'requests_standingInstruction_create_submit',
      CONFIRM: 'requests_standingInstruction_create_confirm',
      DONE: 'requests_standingInstruction_create_done',
      VALIDATION_DAYS: 'requests_standingInstruction_create_validation',
      VALIDATION_MESSAGES: 'requests_standingInstruction_create_validation2',
      BENEFICIARY_NAME: 'requests_standingInstruction_create_beneficiary_name',
      BENEFICIARY_NAME_CONFIRM: 'requests_standingInstruction_create_beneficiary_name_confirm',
      VALIDATION_DAYS_MONTH_YEAR: 'requests_standingInstruction_validation_days_month_year',
    },
  },
  DEBIT_CARD_KEYS: {
    TITLE: 'requests_debitCard_title',
    SUBTITLE: 'requests_debitCard_subtitle',
    BLOCK_DEBIT_CARD: 'requests_debitCard_blockDebitCard',
    CHANGE_CARD_PIN: 'requests_debitCard_changeCardPin',
    CARD_LOAD: 'requests_debitCard_cardLoad',
    BLOCK_DEBIT_CARD_KEYS: {
      TITLE: 'requests_debitCard_blockDebitCard_title',
      SUBTITLE: 'requests_debitCard_blockDebitCard_subtitle',
      ACCOUNT_NUMBER: 'requests_debitCard_blockDebitCard_accountNumber',
      CARD_NUMBER: 'requests_debitCard_blockDebitCard_cardNumber',
      REMARKS: 'requests_debitCard_blockDebitCard_remarks',
      SUBMIT: 'requests_debitCard_blockDebitCard_submit',
      CONFIRM: 'requests_debitCard_blockDebitCard_confirm',
      DONE: 'requests_debitCard_blockDebitCard_done',
    },
    CARD_LOAD_KEYS: {
      TITLE: 'requests_debitCard_cardLoad_title',
      SUBTITLE: 'requests_debitCard_cardLoad_subtitle',
      ACCOUNT_NUMBER: 'requests_debitCard_cardLoad_accountNumber',
      CARD_NUMBER: 'requests_debitCard_cardLoad_cardNumber',
      VERIFY: 'requests_debitCard_cardLoad_verify',
      currency: 'requests_debitCard_cardLoad_currency',
      AMOUNT: 'requests_debitCard_cardLoad_amount',
      SUBMIT: 'requests_debitCard_cardLoad_submit',
      CONFIRM: 'requests_debitCard_cardLoad_confirm',
      DONE: 'requests_debitCard_cardLoad_done',
    },
    CHANGE_CARD_PIN_KEYS: {
      TITLE: 'requests_debitCard_changeCardPin_title',
      SUBTITLE: 'requests_debitCard_changeCardPin_subtitle',
      ACCOUNT_NUMBER: 'requests_debitCard_changeCardPin_accountNumber',
      CARD_NUMBER: 'requests_debitCard_changeCardPin_cardNumber',
      OLD_PIN: 'requests_debitCard_changeCardPin_oldPIN',
      NEW_PIN: 'requests_debitCard_changeCardPin_newPIN',
      CONFIRM_NEW_PIN: 'requests_debitCard_changeCardPin_confirmNewPIN',
      EXPIRY_DATE: 'requests_debitCard_changeCardPin_expiryDate',
      SUBMIT: 'requests_debitCard_changeCardPin_submit',
      CONFIRM: 'requests_debitCard_changeCardPin_confirm',
      DONE: 'requests_debitCard_changeCardPin_done',
    },
  },
}

export const LANDING_KEYS = {
  HI: 'landing_hi',
  INTERNET: 'landing_Internet',
  BANKING: 'landing_Banking',
  DESC: 'landing_desc',
  LOCATE: 'landing_Locate',
  LOAN_ELIGIBLITY: 'landing_Loan',
  CONTACT_US: 'landing_contactUs',
  START: 'landing_Start',
  NO_RECORD: 'No_records',
  BRANCH: 'components_branch_branch',
  ATM: 'components_branch_atm',
  AGENT: 'components_branch_agent',
  CHOOSE: 'Choose_from_the_below_options',
  PLEASE: 'auth_getStarted_please',
  LOCATION_NO_INFO: 'location_no_info',
}

export const CALCULATOR_KEYS = {
  DEPOSITE: 'calculator_depositAmount',
  TENURE: 'calculator_tenure',
  INTEREST_RATE: 'calculator_interestRate',
  CALCULATE: 'calculator_button',
  LOAN: 'calculator_loanAmount',
  CLEAR: 'calculator_clear',
  INTREST_AMOUNT: 'calculator_intrestAmount',
  MONTHLY_INSTALLMENT: 'calculator_monthlyInstallment',
  MATURITY_AMOUNT: 'calculator_maturityAmount',
  TOTAL_AMOUNT: 'calculator_totalAmount',
  LOANS_HEADER: 'calculator_loans',
  DEPOSITS_HEADER: 'calculator_deposits',
}

export const RECIPTS_KEYS = {
  RECEIPT_ID: 'reciepts',
  TRANFER_TYPE: 'transfer_type',
  TRANSACTION_DATE: 'receipt_keys_transaction_date',
  SERVICENO: 'service_number',
  TRANSACTION: 'transaction',
  ACTIONS: 'actions',
  DOWNLOAD: 'download',
  ACCOUNTNO: 'account_number',
  NORECEIPTS: 'no_reciepts',
  SENDER_ACCOUNT: 'sender_account',
  OAT: 'oat',
  RTGS: 'rtgs',
  IAT: 'iat',
  SWIFT: 'swift',
  DDACC: 'ddacc',
  REMARKS: 'receipt_keys_remarks',
  AMOUNT: 'receipt_keys_amount',
  BENE_NAME: 'receipt_keys_bene_name',
  TRANS_CURRENCY: 'receipt_keys_bene_currency',
  TO_ACCOUNT: 'receipt_keys_to_account',
  FROM_ACCOUNT: 'receipt_keys_from_account',
  REF_ID: 'receipt_keys_ref_id',
  SERVICE_NO: 'receipt_keys_service_no',
  TRANSFERS: 'receipt_keys_transfer',
  PAYMENTS: 'receipt_keys_payment',
  FORM_DATE: 'receipt_keys_from_date',
  TO_DATE: 'receipt_keys_to_date',
  SEARCH: 'receipt_keys_search',
  RECP_NO: 'recipt_no',
  PAYMENT_TYPE: 'recipt_payment_type',
  STATUS: 'recipt_status',
}

export const MENU_SIDEBAR_KEYS = {
  ACCOUNTS: 'menu_accounts',
  PAYMENTS: 'menu_payments',
  EXCHANGE_RATE: 'menu_exchange_rates',
  PORTFOLIO: 'menu_protfolio',
  DEPOSITS: 'menu_deposits',
  OTHRT_SERVICES: 'menu_other_services',
  TRANSFERS: 'menu_transfers',
  LOANS: 'menu_loans',
  OFFERS: 'menu_offers',
  FAQ: 'menu_faqs',
  SUGGESTIONS: 'menu_suggestions',
  MT103: 'menu_mt103',
  ACCOUNT_NAME: 'menu_nickName',
  LINK_ACCOUNT: 'menu_linkAccount',
  DELINK_ACCOUNT: 'menu_deLinkAccount',
  BI_STATEMENT: 'menu_bistatement',
  DETAILED_STATEMENT: 'menu_detailedstatement',
  STATEMENT: 'menu_statement',
  PROFILE: 'menu_profile',
  CURRENTMOONTH: 'menu_current_month',
  LASTTWOMONTH: 'menu_last_two_month',
  LASTTHREEMONTH: 'menu_last_three_month',
  CUSTOMDATES: 'menu_custom_dates',
}

export const MENU_SIDEBAR_DETAILS_KEYS = {
  STATEMENT: 'menu_statement_description',
  DESCRIPTION: 'descriptipn',
}

export const PORTFOLIO_KEYS = {
  ASSETS: 'portfolio_assets',
  LIABILITIES: 'portfolio_liability',
  NO_ACCOUNTS: 'portfolio_no_accounts',
  CUSTOMER_ID: 'portfolio_customer_id',
  SAVING_ACC: 'portfolio_saving_account',
  CURRENT_ACC: 'portfolio_current_account',
  LOAN_ACC: 'portfolio_loan_account',
  TERM_DEPOSIT_ACC: 'portfolio_term_deposit_account',
  WALLET_ACC: 'portfolio_wallet_account',
}

export const PROFILE_KEYS = {
  HOME_BRANCH: 'profile_home',
  UPLOAD: 'profile_upload',
  UPLOAD_MESSAGE: 'upload_message',
  brnCode: 'profile_branch',
  DOB: 'profile_dob_profile',
  MOBILE: 'profile_mobno',
  COUNTRY_CODE: 'profile_country_code',
  EMAIL: 'profile_email',
  ADDRESS: 'profile_address_profile',
  MODIFY: 'modify_image',
  MODIFY_BEN: 'modify_ben',
  DELETE_BEN: 'delete_ben',
}

export const PAYMENT_KEYS = {
  SELECT_MERCHANT: 'payment_selectMerchant',
  STUDENT_CLASS_NAME: 'student_class_txt',
  SERVICENO_OR_MOBILENO: 'payment_servicenoormobileno',
  SHORT_NAME: 'payment_addBiller_shortName',
  SUBMIT: 'payment_addBiller_submit',
  TITLE: 'payment_addBiller_title',
  QUESTION_DELETE: 'question_delete_bene',
  VIEW_BILLER: 'payment_serviceType_viewBeneficiary',
  MERCHANT: 'payment_addBiller_merchant',
  SHORT_NAME1: 'payment_addBiller_shortName1',
  DELETE: 'delete',
  NO_BILLER: 'no_biller',
  REMARK: 'payment_billPaymentConfirm_remarks',
  BILLER_NAME: 'payment_billPayment_billername',
  QUOTE_ID: 'payment_billPayment_quoteid',
  PRODUCT: 'payment_billPaymentDetails_product',
  SHOW_BEN: 'payment_billPaymentDetails_showben',
  NO_BEN: 'payment_billPaymentDetails_noben',
  INVOICE: 'payment_invoice',
  RECIEPT: 'payment_receipt',
  BUSINESSID: 'payment_businessid',
  BUSINESSNAME: 'payment_businessname',
  PERSONID: 'payment_personid',
  COMMISSION: 'payment_commission',
  INVOICEAMOUNT: 'payment_invoiceamount',
  TOTAL: 'payment_totalamount',
  PAYMENTTYPE: 'payment_paymenttype',
  DATE: 'payment_date',
  DOWNLOADRECIEPT: 'downlod_reciept',
  DOWNLOADINVOICE: 'downlod_invoice',
  PAY: 'pay',
  PERSONNAME: 'payment_personname',
  INVOICENUMBER: 'payment_invoicenumber',
  AMOUNTINVOICE: 'payment_amount',
  INVOICETITLE: 'invioce_title',
  RECIEPT_TITLE: 'reciept_title',
  SERVICENO: 'service_no',
  BILL_NO: 'bill_no',
  BILL_DATE: 'bill_date',
  BILL_DUE_DATE: 'bill_due_date',
  MOBILE_NO: 'product_mobile_no',
  STUDENT_NO: 'product_student_no',
  ACCOUNT_NO: 'product_account_no',
  BILL_NUMBER: 'product_bill_no',
  SERVICE_NO: 'product_service_no',
  SUBSCRIBER_NO: 'product_subscriber_no',
  IS_REQUIRED: 'validation_required',
  INSURANCE_NO: 'insurance_no',
  NO: 'payment_no',
  CUSTOMER_NO: 'payment_customer_number',
  CUSTOMER_NAME: 'payment_customer_name',
  SCHOOL_BENE_BANK_TYPE: 'school_bene_bank_type',
  SCHOOL_BENE_BANK: 'school_bene_bank',
  CLASS_NAME: 'class_name',
  SCHOOL_NAME: 'school_name',
  STUDENT_NAME: 'student_name',
  SCHOOL_TERM: 'school_term',
  FEES_PURPOSE: 'fees_purpose',
  SCHOOL_YEAR: 'school_year',
  PAYMENT_CUSTOMER_NAME: 'bill_payment_customer_name',
}

export const MENU_KEYS = {
  DASHBOARD: 'menu_key_dashboard',
  ACCOUNTS: 'menu_key_accounts',
  STATEMENT: 'menu_key_statement',
  PROFILE: 'menu_key_profile_settings',
  CHANGE_PASSWORD: 'menu_key_change_password',
  PAYMENTS: 'menu_key_payments',
  QUICK_TRANSFER: 'menu_key_quick_transfer',
  BENEFICIARY_TRANSFER: 'menu_key_beneficiary_transfer',
  REQUEST: 'menu_key_request',
  EXCHANGE_RATE: 'menu_key_exchange_rates',
  PORTFOLIO: 'menu_key_portfolio',
  DEPOSITS: 'menu_key_deposits',
  OTHER_SERVICES: 'menu_key_other_services',
  TRANSFERS: 'menu_key_transfers',
  LOANS: 'menu_key_loans',
  APPLYLOAN: 'menu_key_apply_loan',
  MAKELOAN: 'menu_key_make_loan_payment',
  TERMDEPOSITE: 'menu_key_term_deposit',
  FAQ: 'menu_key_faq',
  SUGGESTIONS: 'menu_key_suggestions',
  INTERNATIONAL_MT103: 'menu_key_international_remittance_receipt',
  ACCOUNT_NAME: 'menu_key_account_name',
  LINK_ACCOUNT: 'menu_key_link_account',
  DELINK_ACCOUNT: 'menu_key_de_link_account',
  DETAILED_STATEMENT: 'menu_key_detailed_statement',
  BI_STATEMENT: 'menu_key_bi_statement',
  QR: 'menu_key_qr_code',
  DOWNLOAD_CENTER: 'menu_key_download_center',
  SUPPORT_CENTER: 'menu_key_support_center',
  CALCULATE: 'menu_key_calculator',
  TC: 'menu_key_terms_and_conditions',
  OFFER: 'menu_key_offers',
  ADD_BILLER: 'menu_key_add_biller',
  PAY_BILL: 'menu_key_pay_bill',
  VIEW_BILLER: 'menu_key_view_biller',
  SERVICES: 'menu_key_services',
  BUY_DATA: 'menu_key_buy_data',
  BUY_AIR: 'menu_key_buy_air_time',
  DOWNLOAD_RECIEPT: 'menu_key_download_receipts',
  INVOICE: 'menu_key_invoice',
  RECIEPT: 'menu_key_receipts',
  SCHOOL_PAYMENT: 'menu_key_school_payments',
  OTHER_PAYMENT: 'menu_key_other_payments',
  CHEQUE: 'menu_key_cheque',
  SI: 'menu_key_si',
  DEBIT_CARD: 'menu_key_debit_card',
  DEBIT_CARD_REQUEST: 'menu_key_debit_card_request',
  DEBIT_CARD_BLOCK: 'menu_key_debit_card_block',
  DEBIT_CARD_ISSUE: 'menu_key_debit_card_issue',
  DEBIT_CARD_DESC: 'menu_key_debit_card_desc',
  DEBIT_CARD_REQUEST_DESC: 'menu_key_debit_card_request_desc',
  DEBIT_CARD_BLOCK_DESC: 'menu_key_debit_card_block_desc',
  DEBIT_CARD_ISSUE_DESC: 'menu_key_debit_card_issue_desc',
  CHEQUE_BOOK: 'menu_key_cheque_book',
  STOP_CHEQUE: 'menu_key_stop_cheque',
  CHEQUE_STATUS: 'menu_key_cheque_status',
  CHEQUE_BOOK_STATUS: 'menu_key_cheque_book_status',
  BENEFICIARY_ADD: 'menu_key_add_beneficiary',
  REPEAT_TRANSFER: 'menu_key_repeat_transfer',
  MANAGE_BENIFICIARY: 'menu_key_manage_beneficiaries',
  INTERNAL_BENEFICIARY: 'menu_key_internal_beneficiary',
  DOMESTIC_BENEFICIARY: 'menu_key_domestic_beneficiary',
  INTERNATIONAL_BENEFICIARY: 'menu_key_international_beneficiary',
  BRANCH: 'menu_key_branch',
  CONTACT: 'menu_key_contact_us',
  ABOUT: 'menu_key_about_us',
  NOTIFICATION: 'menu_key_notifications',
  VIEW_SCHEDULED_TRANSFERS: 'menu_key_view_scheduled_transfers',
  VIEW_SCHEDULED_PAYMENTS: 'menu_key_view_scheduled_payments',
  CARDLESS_CASH: 'menu_key_cardless_cash',
  GENERATE_TOKEN: 'menu_key_generate_token',
  FORM: 'menu_key_form',
  UTILITY_PAYMENTS: 'menu_key_utility_payments',
  PAYMET_DOWNLOAD_RECEIPTS: 'menu_key_payment_download_receipts',
  REPEATE_PAYMENT: 'menu_key_repeat_payment',
  MT103: 'menu_key_mt103',
  MAKE_TRANSFER: 'menu_key_make_transfer',
  VIEW_BENEFICIARIES: 'menu_key_view_beneficiaries',
  INTERNAL: 'menu_key_internal',
  DOMESTIC: 'menu_key_domestic',
  INTERNATIONAL: 'menu_key_international',
  OWN: 'menu_key_own',
  QUICK_PAY: 'menu_key_quick_pay',
  INSTANT_TRANSFER: 'menu_key_instant_transfer',
  SEND_TO_WALLET: 'menu_key_send_to_wallet',
  QR_PAY: 'menu_key_QR_pay',
  STANDING_INSTRUCTION: 'menu_key_standing_instruction',
  CREATE_SI: 'menu_key_create_si',
  CHEQUEBOOK_REQUEST: 'menu_key_cheque_book_request',
  OPEN_ACCOUNT: 'menu_key_open_account',
  TRANSFER_TO_BENE: 'menu_key_transfer_to_bene',
  CHANGE_CARD_PIN: 'menu_key_change_card_pin',
  CARD_LOAD: 'menu_key_card_load',
  BLOCK_DEBIT_CARD: 'menu_key_block_debit_card',
  SI_VIEW: 'menu_key_si_view',
  DESCRIPTION_HERE: 'menu_desc_description_here',
  VIEWSTMT: 'menu_desc_stmt',
  PURCHASE_AIRTIME: 'menu_desc_purchase_airtime',
  QUICK_FT: 'menu_desc_quick_ft',
  TRANSFER_MONEY_BENE: 'menu_desc_transfer_money_bene',
  ACCOUNT_DEPOSIT: 'menu_desc_account_deposit',
  GENERATE_TOKEN_DESC: 'menu_desc_generate_token',
  ADD_BENEFICIARY: 'menu_desc_add_beneficiary',
  INSTANT_FT: 'menu_desc_instant_ft',
  SEND_MONEY_TO_MOBILE: 'menu_desc_send_money_to_mobile',
  SEND_MONEY_TO_BENEFICIARY: 'menu_desc_send_money_to_bene',
  MAKE_PAYMENT_AGAIN: 'menu_desc_make_payment_again',
  VIEW_BENEFICIARY_DETAILS: 'menu_desc_view_beneficiary_details',
  SERVICE_PROVIDER_BENE: 'menu_desc_service_provider_bene',
  ALL_PEROVIDER_BENE: 'menu_desc_all_provider_bene',
  ADD_MAKE_BILL_PAYMENT: 'menu_desc_add_make_bill_payment',
  BILLER_BUY_DATA: 'menu_desc_biller_Buy_data',
  BILLER_BUY_AIRTIME: 'menu_desc_biller_buy_airtime',
  DOWNLOAD_YOUR_RECIEPT: 'menu_desc_download_your_receipts',
  DESC_EXCHANGE_RATE: 'menu_desc_exchange_rates',
  CHECK_BOOK_ORDERS: 'menu_desc_cheque_book_orders',
  ORDER_CANCEL_CHEQUE_STATUS: 'menu_desc_order_cancel_cheque_status',
  ORDER_CHEQUE_BOOK: 'menu_desc_order_cheque_book',
  DESC_STOP_CHECK: 'menu_desc_stop_cheque',
  VIEW_CHEQUE_STATUS: 'menu_desc_view_cheque_status',
  VIEW_CHEQUE_BOOK_STATUS: 'menu_desc_view_cheque_book_status',
  CREATE_VIEW_SI: 'menu_desc_create_view_si',
  LINK_YOUR_ACCOUNT: 'menu_desc_link_your_account',
  REMOVE_YOUR_ACCOUNT: 'menu_desc_remove_your_account',
  ACCOUNT_NICKNAME: 'menu_desc_account_nickname',
  VIEW_DOWNLOAD_RECEIPT: 'menu_desc_view_download_receipts',
  DOWNLOAD_DETAILED_STMT: 'menu_desc_download_detailed_stmt',
  DOWNLOAD_RTGS_TT: 'menu_desc_download_rtgs_tt',
  FIND_ATM_LOCATION: 'menu_desc_find_atm_location',
  FREQUENTLY_ASKED_QUESTIONS: 'menu_desc_frequently_asked_questions',
  FEEDBACK_AND_SUGGESTIONS: 'menu_desc_feedback_suggestions',
  BANK_CONTACT_DETAILS: 'menu_desc_bank_contact_details',
  VISION_MISSION_BANK: 'menu_desc_vision_mission_bank',
  TNC: 'menu_desc_tnc',
  CURRENT_BANK_OFFER: 'menu_desc_current_bank_offers',
  OPEN_NEW_ACCOUNT: 'menu_desc_open_new_account',
  MAKE_SCHOOL_PAYMENT: 'menu_desc_make_school_payments',
  MAKE_OTHER_PAYMENT: 'menu_desc_other_payment',
  CREATE_SI_DESC: 'menu_desc_si',
  VIEW_SI: 'menu_desc_view_si',
  CURRENTMONTH: 'menu_key_current_month',
  LASTTWOMONTH: 'menu_key_last_two_month',
  LASTTHREEMONTH: 'menu_key_last_three_month',
  CUSTOMDATES: 'menu_key_custom_dates',
  DOWNLOAD_CENTER_DESC: 'menu_desc_download_center',
  SUPPORT_CENTER_DESC: 'menu_desc_support_center',
  VIEW_SCHEDULED_TRANSFERS_DESC: 'menu_desc_view_scheduled_transfers',
  VIEW_SCHEDULED_PAYMENTS_DESC: 'menu_desc_view_scheduled_payments',
  REGIONAL_TRANSFER: 'menu_key_regional_transfer',
  REGIONAL: 'menu_key_regional',
  CREATE_TERM_DEPOSITS: 'menu_key_create_term_deposits',
  QR_DESC: 'menu_desc_qr',
  PORTFOLIO_DESC: 'protfolio',
  ACCOUNT_DESC: 'account_desc',
  TRANSFER_DESC: 'transfer_desc',
  PAYMENT_DESC: 'payment_desc',
  SUPPORT_DESC: 'support_desc',
  DEPOSIT_DESC: 'deposit_description',
  REQUEST_DESC: 'request_desc',
  OTHER_SERVICE_DESC: 'otherServices_desc',
  GIMAC: 'menu_keys_gimac',
  ATM_PROVISION: 'atm_provision',
}

export const VALIDATION = {
  USERNAME: 'validation_username_required',
  PASSWORD: 'validation_password_required',
  ACCOUNTNO: 'validation_account_required',
  ACCOUNTNOVALID: 'validation_valid_account_no',
  USERNAMEVALID: 'validation_username',
  MOBILENO: 'validation_mobile_no_required',
  DOB: 'validation_dob_required',
  PASSWORDVALID: 'validation_password_length',
  NEWPASSWORD: 'validation_new_password_required',
  OTP: 'validation_opt',
  CONFIRMNEWPASSWORD: 'validation_confirm_new_password_required',
  PASSWORDNOTMATCH: 'validation_password_match',
  REQUIRED: 'validation_required_field',
  MOBILENOVALID: 'validation_valid_mobile_no',
  MOBILENOVALID1: 'validation_bene_mobile_no',
  IDENTITY_TYPE: 'validation_identity_type',
  IDENTITY_NO: 'validation_identity_no',
  NICK_NAME: 'validation_nick_name',
  NICK_NAME_VALID: 'validation_nick_name_length',
  CONFIRMACCOUNTNUMBER: 'validation_confirm_account_no_required',
  CONFIRMACCOUNTNUMBERVALID: 'validation_confirm_account_no_match',
  TRANSFERLIMIT: 'validation_transfer_limit_required',
  BENEFICIARYNAME: 'validation_beneficiary_name_required',
  BENEFICIARYNAMEVALID: 'validation_baneficiary_name_validation',
  ACCOUNTNOVALID1: 'validation_account_no_digit',
  BENIFICIARYBANK: 'validation_bene_bank',
  BENIFICIARYBRANCH: 'validation_branch_name_required',
  AMOUNT: 'validation_amount_Required',
  REMARKS: 'validation_remarks_required',
  SCHUEDULETRANSFER: 'validation_scheduled_transfer_required',
  SCHEDULEDATE: 'validation_schdeuled_date_required',
  TRANSFERAMOUNT: 'validation_traansfer_amount_required',
  currency: 'validation_currency_required',
  CUSTOMTREMARK: 'validation_custom_remarks_required',
  LOANAMOUNT: 'validation_loan_amount_is_required',
  DEPOSITEAMOUNT: 'validation_deposit_amount_required',
  GREATER: 'validation_greater_than',
  TENURE: 'validation_tenure_required',
  TENUREVALID: 'validation_tenure',
  INTERESTRATE: 'validation_interest_rate_required',
  INTEREST_RATEVALID: 'validation_interest_rate',
  FEEDBACK: 'validation_feedback_required',
  FEEDBACKVALID: 'validation_feedback_length',
  FEEDBACKCATEGORY: 'validation_feedback_category_required',
  SERVICENO: 'validation_service_no_required',
  PRODUCT: 'validation_product_is_required',
  REGACCOUNTNOVALID: 'validation_account_no_not_valid',
  CHARGESBORNEBY: 'validation_charge_borne_by_required',
  CREDIT_ACCOUNT_NUMBER: 'validation_credit_account_no_required',
  OTHER_BANK_ACCOUNT_NO: 'validation_other_bank_account_no',
  OLD_PASSWORD: 'validation_old_password_required',
  BANK_ADDRESS: 'validation_bank_address',
  BENEFICIARIE_COUNTRY: 'validation_beneficiary_country',
  BENEFICIARY_EMAIL: 'validation_beneficiary_mail',
  BENEFICIARY_EMAIL_VALID: 'validation_beneficiary_email_valid',
  BENE_MOBILENO: 'validation_beneficiary_mobile_no',
  BANK_COUNTRY: 'validation_bank_country',
  ADDRESS: 'validation_address',
  SENDER_TO_RECEIVER: 'validation_sender_to_receiver',
  FX_NO: 'validation_fx_no',
  ALPHABETS_ONLY: 'validation_alphabets_only',
  MOBILE_NUMBER_LENGTH: 'validation_mobile_number_length',
  MIN_MAX_MOBILE_NUMBER_LENGTH: 'validation_min_max_mobile_number_length',
}
export const VIEW_SCHEDULED_KEY = {
  REFERENCE_NO: 'refernce_no',
  DESTINATION_ACCOUNT_NUMBER: 'destination_account',
  SOURCE_ACCOUNT_NUMBER: 'source_account_number',
  SCHEDULED_AMOUNT: 'scheduled_amount',
  SERVICE_CODE: 'service_code',
  ACTIONS: 'actions',
  SCHEDULED_CANCEL: 'scheduled_cancel',
  SCHEDULED_ACTIVE_STATUS: 'scheduled_active_status',
  SCHEDULEDATE: 'scheduled_date',
  SCHEDULED_CREATED_DATE: 'scheduled_created_date',
  SCHEDULED_TXN_STATUS: 'scheduled_txnStatus',
  SCHEDULED_SOURCE_ACCOUNT_CURRENCY: 'scheduled_srcAccountCcy',
  SCHEDULED_TXN_CCY: 'scheduled_txnCcy',
  SCHEDULED_ID: 'view_scheduled_id',
  NOSCHEDULED: 'no_scheduled',
  OAT: 'oat',
  RTGS: 'rtgs',
  IAT: 'iat',
  SWIFT: 'swift',
  DDACC: 'ddacc',
  RECEIPT_NO: 'scheduled_receipt_no',
  SERVICE_PROVIDER: 'scheduled_service_provider',
  SERVICENO: 'scheduled_service_no',
  SCHEDULED_STATUS: 'scheduled_status',
}
// module.exports = {
//   SIDENAV_KEYS,
//   VALIDATION_MESSAGES,
//   DIALOG_KEYS,
//   LOAN_KEYS,
//   DEPOSITS_KEYS,
//   ACCOUNT_KEYS,
//   AUTH_KEYS,
//   KEYBOARD_DIALOG,
//   PAYDAY_LOANS_KEYS,
//   BENEFICIARY_TRANSFER_KEYS,
//   REQUESTS_KEYS,
//   LANDING_KEYS,
//   CALCULATOR_KEYS,
//   RECIPTS_KEYS,
//   MENU_SIDEBAR_KEYS,
//   PORTFOLIO_KEYS,
//   MENU_SIDEBAR_DETAILS_KEYS,
//   PROFILE_KEYS,
//   PAYMENT_KEYS,
//   MENU_KEYS,
//   VALIDATION,
// }

export const CLIENT_NAME = {
  CLIENT_CARD_LABEL: 'client_card_label',
  CLIENT_HEADER_LABEL: 'client_header_label',
}
export const HEADER_SUBTITLE = {
  HEADER_BANK_SLOGAN: 'header_bank_slogan',
}
export const ART_WORK_KEYS = {
  LINK_YOUR_ACCOUNT_DESC: 'link_your_account_desc',
  VIEW_CONTACT_DETAILS_DESC: 'view_contact_details_desc',
  VIEW_BANK_DESC: 'view_bank_desc',
  REMOVE_YOUR_ACCOUNT_DESC: 'remove_your_account_desc',
  GIVE_YOUR_ACCOUNT_NAME_DESC: 'give_your_account_name_desc',
  DEBIT_CARD_DESC: 'menu_key_debit_card_desc',
  DOWNLOAD_RECIEPT_STATEMENT_DESC: 'download_reciept_statement_desc',
  DOWNLOAD_RECIEPT_PAYMENT_DESC: 'download_reciept_payment_desc',
  DOWNLOAD_RECIEPT_INVOICE_DESC: 'download_reciept_invoice_desc',
  DOWNLOAD_RECIEPT_DESC: 'download_reciept_desc',
  NOTIFICATION_DESC: 'notification_desc',
  PROFILE_SETTINGS_DESC: 'profile_setting_desc',
  CHANGE_PASSWORD_DESC: 'change_password_desc',
  ADDITIONAL_LINKS_DESC: 'additional_links_desc',
  SUPPORT_CENTER_DESC: 'support_center_desc',
  LOAN_DESC: 'loan_desc',
  SI_DESC: 'si_desc',
  BENE_REPEAT_DESC: 'bene_repeat_desc',
  RECEIPTS_DESC: 'receipts_desc',
  BI_STATEMENT_DESC: 'bi_statement_desc',
  MT103_DESC: 'mt103_desc',
  SCHEDULED_PAYMENT_DESC: 'scheduled_payment_desc',
  BRANCH_DESC: 'branch_desc',
  DEPOSIT_DESC: 'deposit_desc',
  FAQ_DESC: 'faq_desc',
  SUGGESTIONS_DESC: 'suggestion_desc',
  CALCULATOR_DESC: 'calculator_desc',
  OFFERS_DESC: 'offers_desc',
  EXCHANGE_RATES_DESC: 'exchange_rates_desc',
  SCHOOL_PAYMENT_DESC: 'school_payment_desc',
  ADD_BILLER_DESC: 'add_biller_desc',
  VIEW_BILLER_DESC: 'view_biller_desc',
  OTHER_PAYMENT_DESC: 'other_payment_desc',
  ADD_ACCOUNT_DESC: 'add_account_desc',
  SCHEDULED_TRANSFER_DESC: 'scheduled_transfer_desc',
}

export const DEFAULT_ERROR_KEYS = {
  DEFAULT_ERROR_CODE: 'default_error_code',
  DEFAULT_ERROR_MESSAGE: 'default_error_message',
  DEFAULT_ERROR_HEADER: 'default_error_header',
}

export const DEBIT_CARD_KEYS = {
  ACCOUNT_NO: 'debit_card_lbl_accountNo',
  BRANCH_NAME: 'debit_card_lbl_branchName',
  CURRENCY: 'debit_card_lbl_currency',
  BACK: 'debit_card_link_back',
  SUBBMIT: 'debit_card_btn_submit',
  CONFIRM: 'debit_card_btn_confirm',
  BRANCH: 'debit_card_branch',
  ADDRESS: 'debit_card_address',
  NEW: 'debit_card_new',
  RENEWAL: 'debit_card_renewal',
  REPLACEMENT: 'debit_card_replacement',
  REQUEST_TYPE: 'debit_card_request_type',
  CARD: 'debit_card_card_deatils',
  DELIVERY_MODE: 'debit_card_delivery_mode',
  TITLE: 'debit_card_request_title',
  SUBTITLE: 'debit_card_request_subtitle',
}

export const CARDLESS_CASH_KEYS = {
  RECEIVER_MOBILE_NO: 'cardless_cash_receiver_mobile_no',
  AMOUNT: 'cardless_cash_amount',
  VALIDITY_HRS: 'cardless_cash_validity_hrs',
  VALIDATIY: 'cardless_cash_validity',
  CHARGES: 'cardless_cash_charges',
  REMARKS: 'cardless_cash_remarks',
  TRANSACTION_CURRENCY: 'cardless_cash_transaction_currency',
  TOKEN_NO: 'cardless_cash_token_no',
  EXPIRY_DATE: 'cardless_cash_expiry_date',
  REFERENCE: 'cardless_cash_reference',
  STATUS: 'cardless_cash_status',
  ACCOUNT_NUMBER: 'cardless_cash_account_number',
  CUSTOMER_ID: 'cardless_cash_customer_id',
  MOBILE_NO: 'cardless_cash_mobile_no',
  CREATE_DATE: 'cardless_cash_create_date',
  CANCEL_TOKEN: 'cardless_cash_cancel_token',
  GENERATE_TOKEN: 'cardless_cash_generate_token',
  AMOUNT_VALIDITY: 'cardless_cash_amount_validity',
  TITLE: 'cardless_cash_amount_title',
  NO_RECORDS: 'cardless_cash_amount_no_records',
  SEARCH: 'cardless_cash_search',
  SEARCH_BY: 'cardless_cash_search_by',
  SELECT_STATUS: 'cardless_cash_select_status',
}

export const BANNER_KEYS = {
  PROFILE: 'banner_keys_profile',
  CHANGE_PASSWORD: 'banner_keys_change_password',
  LOGOUT: 'banner_keys_logout',
  LOGOUT_CONFIRM_MESSAGE: 'banner_keys_logout_confirm_message',
  YES: 'banner_keys_yes',
  CANCEL: 'banner_keys_cancel',
  LOGOUT_SUCCESS: 'banner_keys_logout_success',
}
export const ACCOUNT_CARD_KEYS = {
  AVAILABLE_BALANCE: 'account_card_keys_available_balance',
  SELECT_OPERATION: 'account_card_keys_select_operation',
  OPEN_ACCOUNT: 'account_card_keys_open_account',
  OPEN_ACCOUNT_DESC: 'account_card_keys_open_account_desc',
  ACCOUNT_TYPE: 'account_card_keys_account_type',
  ACC_NICK_NAME: 'account_card_keys_acc_nick_name',
  ACC_HOLDER_NAME: 'account_card_keys_acc_holder_name',
  CUST_ID: 'account_card_keys_cust_id',
  BRANCH: 'account_card_keys_branch',
  SORT_CODE: 'account_card_keys_sort_code',
  SWIFT_CODE: 'account_card_keys_swift_code',
  CURRENCY: 'account_card_keys_currency',
  AVA_BALANCE: 'account_card_keys_ava_balance',
  CURRENT_BALANCE: 'account_card_keys_current_balance',
  ACC_OPEN_DATE: 'account_card_keys_acc_open_date',
  ACC_DESC: 'account_card_keys_acc_desc',
  VIEW_ACC_DETAILS: 'account_card_keys_view_acc_details',
  CURRENT_ACC: 'account_card_keys_currenct_acc',
  SAVING_ACC: 'account_card_keys_saving_acc',
  WALLET_ACC: 'account_card_keys_wallet_acc',
  ACCOUNT_CLASS: 'account_card_keys_account_class',
  FUNDING_ACC_NO: 'account_card_keys_wallet_funding_acc_no',
  BRANCH_CODE: 'account_card_keys_wallet_branch_code',
  CONFIRM_ACC_DETAILS: 'account_card_keys_confirm_acc_details',
  CURRENT_ACCOUNT: 'account_card_keys_current_account',
  AVAILABLE_ACCOUNT: 'account_card_keys_available_account',
  ACC_NO: 'account_card_keys_acc_no',
}
